/* eslint-disable max-lines */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      visit: {
         actionBar: {
            certificate: 'Zaświadczenie lekarskie',
            confirm: 'Zatwierdź',
            confirmAndPrint: 'Zatwierdź i drukuj',
            confirmAndShare: 'Zatwierdź i udostępnij',
            confirmAndShareTooltip: 'Ta opcja jest na razie niedostępna dla pozostałych dokumentów z wizyty.',
            confirmLater: 'Zapisz i zamknij',
            consentTemplate: {
               label: 'Zgody',
               modal: {
                  actions: {
                     close: 'Zamknij',
                  },
                  form: {
                     actionInput: {
                        placeholder: 'Wyszukaj dokument zgód i upoważnień po nazwie...',
                     },
                     table: {
                        headers: {
                           name: 'Nazwa dokumentu',
                        },
                        options: {
                           fill: {
                              label: 'Uzupełnij',
                           },
                           finish: {
                              label: 'Dokończ',
                           },
                           markAsFavorite: {
                              successMessage: 'Dokument został dodany do ulubionych.',
                              tooltipMessage: 'Dodaj do ulubionych',
                           },
                           unmarkAsFavorite: {
                              successMessage: 'Dokument został usunięty z ulubionych.',
                              tooltipMessage: 'Usuń z ulubionych',
                           },
                        },
                        placeholder: 'Brak pasujących zgód lub upoważnień',
                     },
                  },
                  title: 'Zgody i upoważnienia',
               },
            },
            documentTemplate: {
               form: {
                  actionInput: {
                     placeholder: 'Wyszukaj druk po nazwie...',
                  },
                  table: {
                     headers: {
                        name: 'Nazwa druku',
                     },
                     options: {
                        favorite: {
                           markAsFavorite: {
                              successMessage: 'Druk został dodany do ulubionych.',
                              tooltipMessage: 'Dodaj do ulubionych',
                           },
                           unmarkAsFavorite: {
                              successMessage: 'Druk został usunięty z ulubionych.',
                              tooltipMessage: 'Usuń z ulubionych',
                           },
                        },
                        fill: {
                           label: 'Uzupełnij',
                        },
                        finish: {
                           label: 'Dokończ',
                        },
                     },
                     placeholder: 'Brak pasujących druków.',
                  },
                  tabsMap: {
                     ASSESSMENTS: 'Orzeczenia',
                     CERTIFICATES: 'Zaświadczenia',
                     EXAMINATION_CARDS: 'Karty badań',
                     FAVORITES: 'Ulubione druki',
                     OTHER: 'Inne',
                     REFERRALS: 'Skierowania',
                     TESTS_AND_SCALES: 'Testy i skale',
                  },
               },
               label: 'Druki',
               modal: {
                  confirm: 'Zamknij',
                  title: 'Druki',
               },
               options: {
                  medicalCertificate: 'Zaświadczenie lekarskie',
                  referralToAnalyticalExamination: 'Skierowanie do laboratorium',
                  referralToDiagnosticExamination: 'Skierowanie do pracowni diagnostycznej',
                  referralToHospital: 'Skierowanie do szpitala',
                  referralToPsychiatricHospital: 'Skierowanie do szpitala psychiatrycznego',
                  referralToRehabilitation: 'Skierowanie na rehabilitację',
                  referralToSpecialist: 'Skierowanie do specjalisty',
               },
            },
            educationalMaterialsForPatient: 'Materiały dla pacjenta',
            electronicDocuments: 'eDokumenty',
            goBackToAppointments: 'Wróć do listy wizyt',
            goBackToPatientList: 'Wróć do listy pacjentów',
            medicalLeave: 'eZwolnienie',
            nextVisit: 'Kolejna wizyta',
            prescription: 'eRecepta',
            prescriptionVisitData: {
               changesSaved: 'Zapisano zmiany',
               label: 'Dane podstawowe wizyty',
            },
         },
         alreadyCancelled: 'Wizyta została już anulowana.',
         alreadyRegistered: 'Wizyta została już zaplanowana.',
         alreadyStarted: 'Wizyta została już rozpoczęta.',
         appointmentOutOfSchedule: {
            label: 'Rozpocznij wizytę',
            successMessage: 'Utworzono wizytę bez rejestracji.',
         },
         appointments: {
            accountPartiallyBlocked:
               'Twoje konto zostało częściowo zablokowane z powodu nieopłaconej w terminie faktury - opłać fakturę i skontaktuj się z działem sprzedaży.',
            appointmentConfirmationStatusFilter: {
               chosenOf: 'Wybrano {{count}} z {{totalCount}}',
               filterLabel: 'Status potwierdzenia: {{confirmationStatuses}}',
               filterLabelAll: 'Wszystkie',
               selectAll: 'Wybierz wszystkie',
               selectConfirmationStatuses: 'Wybierz statusy potwierdzenia',
            },
            appointmentConfirmationStatusMap: {
               CONFIRMED: 'Potwierdzona',
               NOT_CONFIRMED: 'Niepotwierdzona',
            },
            appointmentConfirmationStatusUpdateAvailableOnlyInPlannedStatus:
               'Status możliwy do zmiany tylko dla wizyt w statusie "Zaplanowana".',
            appointments: 'Wizyty',
            cancel: 'Anuluj',
            cancelPlannedAppointment: 'Odwołaj',
            cancellingIsNotPossible: 'Nie można odwołać wizyty, która została rozpoczęta',
            cancellingIsNotPossibleInOrganization:
               'Nie można anulować wizyty, podczas której wystawiono dokument lub która została zrealizowana przez innego specjalistę.',
            cancellingIsNotPossibleInPractice: 'Nie można anulować wizyty, podczas której wystawiono dokument',
            cannotCancelReopenedVisit: 'Nie można anulować wizyty, która została ponownie otwarta.',
            cannotCancelVisitWhenChronicDiseaseExists:
               'Nie można anulować wizyty, podczas której wystawiono dokument lub stwierdzono rozpoznanie przewlekłe.',
            create: {
               form: {
                  dateConfirmedWithPatient: {
                     label: 'Termin ustalony z pacjentem',
                  },
                  dayOfWeeks: 'Powtarzaj w dni',
                  errors: {
                     fetchData: 'Wystąpił błąd pobierania danych na potrzeby stworzenia nowej wizyty.',
                  },
                  estimatedDuration: 'Czas trwania wizyty',
                  healthcareProviderLocation: {
                     label: 'Miejsce Udzielania Świadczeń',
                  },
                  note: {
                     action: 'Dodaj notatkę',
                     label: 'Notatka do wizyty',
                  },
                  overlappingStrategy: {
                     anyway: 'Zarejestruj mimo to',
                     label: 'Co zrobić, jeśli w danym terminie jest już inna wizyta?',
                     skip: 'Omiń pokrywające się terminy',
                  },
                  patient: {
                     createAction: {
                        label: 'Dodaj nowego pacjenta',
                     },
                  },
                  recurrence: 'Powtarzaj',
                  recurrencePeriod: 'Powtarzaj co',
                  recurrencePeriodUnit: {
                     type: {
                        DAYS: 'dni',
                        MONTHS: 'miesięcy',
                        WEEKS: 'tygodni',
                     },
                  },
                  recurrencePeriodValue: '{{periodValue}}',
                  recurrenceType: {
                     SAME_DAY_OF_MONTH: 'Miesiąca',
                     SAME_DAY_OF_WEEK: 'Tygodnia {{dayName}}',
                     label: 'W dany dzień',
                  },
                  totalNumberOfAppointments: {
                     label: 'Koniec po',
                     unit: 'wizytach',
                  },
                  videoConsultation: {
                     label: 'Wideokonsultacja',
                     tooltipContent:
                        'Jeśli tworzysz wideokonsultację, link do spotkania zostanie wysłany do pacjenta e-mailem lub e-mailem i SMS-em',
                  },
               },
               modal: {
                  confirm: {
                     register: 'Zarejestruj',
                     registerAndGoBack: 'Zarejestruj i {{label}}',
                  },
                  title: {
                     register: 'Zarejestruj wizytę',
                  },
               },
            },
            dateHour: 'Data i godzina',
            datetime: 'Data i czas',
            diagnosis: 'Rozpoznanie',
            doctor: 'Lekarz',
            entitlementToMedicalService: 'eWUŚ',
            filters: {
               allSpecialists: 'Wszyscy specjaliści',
               allSpecialistsChosen: 'Wybrano wszystkich specjalistów',
               chooseSpecialists: 'Wybierz specjalistów',
               chosenSpecialists: 'Wybrano {{doctorsCount}} specjalistów',
               day: 'Dzień',
               range: 'Zakres',
               selectedFilters: 'Wybrane filtry',
               specialist: 'Specjalista: {{firstName}} {{lastName}}',
               specialistsCount: '{{count}} specjalistów',
               today: 'Dzisiaj',
               unknownSpecialist: 'Nieznany specjalista',
            },
            finish: 'Dokończ',
            invoice: 'Faktura',
            loading: 'Ładowanie wizyt',
            mainDiagnosis: 'Rozpoznanie główne:',
            markAppointmentConfirmationStatusAsConfirmed: 'Oznacz, że pacjent potwierdził obecność.',
            markAppointmentConfirmationStatusAsNotConfirmed: 'Cofnij potwierdzenie obecności pacjenta.',
            markPatientPresenceAsUnknown: 'Cofnij oznaczenie pacjenta w poczekalni.',
            markPatientPresenceAsWaiting: 'Oznacz, że pacjent jest w poczekalni.',
            medicalEvents: 'ZM',
            medicalProfile: {
               actions: {
                  close: 'Zamknij',
                  save: 'Zapisz zmiany',
               },
               add: 'Dodaj +',
               button: 'Profil medyczny',
               entry: {
                  add: 'Dodaj wpis',
                  remove: 'Usuń wpis',
               },
               fetchError: 'Nie udało się pobrać profilu medycznego.',
               gateOptionMap: {
                  NO: 'Nie',
                  REFUSED: 'Odmowa odpowiedzi',
                  UNKNOWN: 'Pacjent nie wie',
                  YES: 'Tak',
               },
               modalConfirmExit: {
                  confirm: 'Wyjdź',
                  content: 'Czy chcesz wyjść z formularza? <bold>Utracisz niezapisane dane. </bold>',
               },
               save: {
                  failure: 'Nie udało się zapisać części sekcji: {{sections}}.',
                  success: 'Zapisano zmiany w profilu medycznym.',
                  surveyNotUpdatable: 'Nie można zaktualizować ankiety.',
               },
               showOnVisit: {
                  details: 'Szczegóły',
                  label: 'Pokaż na wizycie',
                  lastUpdate: 'Ostatnia aktualizacja',
               },
               subtitle: {
                  lastUpdate: 'Ostatnia aktualizacja {{date}}',
                  noData: 'Brak danych',
               },
               tabs: {
                  general: 'Profil ogólny',
                  neurology: 'Neurologia',
               },
               title: 'Profil medyczny',
            },
            noAppointments: {
               noAppointments: 'Brak wizyt',
               noResults: 'Brak wyników spełniających kryteria wyszukiwania',
            },
            options: 'Opcje',
            patient: 'Pacjent',
            patientGroupFilter: {
               chosenOf: 'Wybrano {{count}} z {{totalCount}}',
               filterLabel: 'Oznaczenie pacjenta: {{patientGroups}}',
               filterLabelAll: 'Wszystkie',
               selectAll: 'Wybierz wszystkie',
               selectPatientGroups: 'Wybierz oznaczenia pacjentów',
            },
            patientHistory: 'Historia pacjenta',
            patientPresenceMap: {
               PRESENT: 'W poczekalni',
               UNKNOWN: 'Nieokreślony',
            },
            patientPresenceStatusFilter: {
               chosenOf: 'Wybrano {{count}} z {{totalCount}}',
               filterLabel: 'Status obecności: {{patientPresences}}',
               filterLabelAll: 'Wszystkie',
               selectAll: 'Wybierz wszystkie',
               selectPatientPresenceStatuses: 'Wybierz statusy obecności',
            },
            preInterview: {
               failedToFetch: 'Nie udało się pobrać danych. Spróbuj ponownie.',
               modal: {
                  create: {
                     form: {
                        actions: {
                           confirm: {
                              successMessage: 'Odpowiedzi zostały zatwierdzone.',
                              title: 'Zatwierdź',
                           },
                           save: { successMessage: 'Odpowiedzi zostały zapisane.', title: 'Zapisz' },
                        },
                        errors: {
                           noAnswersProvidedFault: 'Wymagana odpowiedź na co najmniej jedno pytanie.',
                           preInterviewExpiredFault: 'Minął czas na uzupełnienie pre-wywiadu dla wskazanej wizyty.',
                           surveyNotUpdatableFault: 'Nie udało się zapisać odpowiedzi.',
                        },
                     },
                  },
                  preview: {
                     actions: {
                        close: 'Zamknij',
                        previewVisit: 'Podgląd wizyty',
                     },
                     noAnswerContentPlaceholder: 'Brak odpowiedzi',
                  },
                  shared: {
                     form: {
                        questionAnswer: {
                           placeholder: 'Wpisz odpowiedź...',
                        },
                        validation: {
                           minimalData: 'Wymagana odpowiedź na co najmniej jedno pytanie.',
                        },
                     },
                     title: 'Pre-wywiad',
                  },
                  update: {
                     form: {
                        errors: {
                           surveyNotUpdatableFault: 'Minął czas na uzupełnienie pre-wywiadu dla wskazanej wizyty.',
                        },
                     },
                  },
               },
               modalConfirmExit: {
                  confirm: 'Wyjdź',
                  content: 'Czy chcesz wyjść z formularza? <bold>Utracisz niezapisane dane. </bold>',
               },
               table: {
                  column: {
                     actions: {
                        create: {
                           title: 'Dodaj',
                           tooltipContent:
                              'Pre-wywiad nie może być dodany później niż dobę po terminie zaplanowanej wizyty.',
                        },
                        preview: 'Podgląd',
                        update: 'Edytuj',
                     },
                     title: 'Pre-wywiad',
                  },
               },
            },
            receptionServicesHaveBeenChangedAdvancePaymentMayRequiredAnAdditionalPaymentOrRefund:
               'Zostały zmienione usługi - przedpłata może wymagać dopłaty lub zwrotu. Zapisz zmiany, aby móc ją rozliczyć.',
            reopenVisit: 'Otwórz ponownie',
            reopenVisitModal: {
               confirm: 'Otwórz ponownie',
               enterReason: 'Podaj powód ponownego otwarcia...',
               exitConfirmationModal: {
                  cancel: 'Anuluj',
                  confirm: 'Wyjdź',
                  message:
                     'Czy na pewno chcesz opuścić formularz otwarcia wizyty? Uzupełniony powód zostanie utracony.',
                  title: 'Wychodzisz z formularza otwarcia wizyty',
               },
               reason: 'Powód',
               successMessage: 'Otwarto ponownie wizytę',
               title: 'Ponowne otwarcie wizyty',
            },
            restore: 'Zaplanuj ponownie',
            selectedSlotIsNotInSchedule: 'Wybrany termin wykracza poza zdefiniowane dostępności.',
            serviceLocationWarning: {
               notAllServicesAreRealizedInSelectedServiceLocation:
                  'Nie wszystkie usługi dodane do rezerwacji są realizowane w wybranym MUŚ.',
            },
            shared: {
               patientCreate: {
                  form: {
                     phone: {
                        label: 'Telefon',
                     },
                     validation: {
                        minimalData: 'Należy wypełnić przynajmniej jedno pole',
                     },
                  },
                  modal: {
                     confirm: {
                        successMessage:
                           'Pomyślnie dodano pacjenta - przed rozpoczęciem wizyty konieczne będzie dodanie brakujących danych.',
                     },
                     title: 'Dodaj nowego pacjenta',
                  },
               },
            },
            show: 'Podgląd',
            specialist: 'Specjalista',
            start: 'Rozpocznij',
            status: 'Status',
            statusCode: {
               CANCELLED: 'Anulowana',
               FINISHED_APPROVED: 'Zatwierdzona',
               FINISHED_NOT_APPROVED: 'Niezatwierdzona',
               IN_PROGRESS: 'W trakcie',
               REGISTERED: 'Zaplanowana',
            },
            successfullyCancelledPlannedVisit:
               'Pomyślnie odwołano wizytę - w każdym momencie możesz ją zaplanować ponownie.',
            successfullyCancelledVisit: 'Pomyślnie anulowano wizytę - w każdym momencie możesz ją zaplanować ponownie.',
            successfullyCreatedNewAppointment: 'Pomyślnie zarejestrowano wizytę.',
            successfullyUpdatedAppointment: 'Zmiany zostały zapisane.',
            thisVisitRequiredAdvancePayment:
               'Ta wizyta wymaga przedpłaty. Po zakończeniu rejestracji będzie można wygenerować link do płatności.',
            timeSlotOccupied: 'Termin zajęty',
            timeSlotTaken: 'Nie udało się utworzyć wizyty - na ten czas jest już zaplanowana inna wizyta.',
            title: 'Wizyty',
            unknownPatient: 'Nieznany pacjent',
            unsuccessfulUpdatedAppointment: 'Nie udało się zaktualizować wizyty.',
            update: {
               form: {
                  date: 'Data',
                  endTime: 'Godzina zakończenia',
                  errors: {
                     fetchData: 'Wystąpił błąd pobierania danych na potrzeby aktualizacji wizyty.',
                  },
                  startTime: 'Godzina rozpoczęcia',
               },
               modal: {
                  confirm: {
                     restore: 'Zaplanuj ponownie',
                     update: 'Zapisz',
                  },
                  title: {
                     restore: 'Zaplanuj ponownie',
                     update: 'Edytuj wizytę',
                  },
               },
               title: 'Edytuj',
            },
            updateTerm: 'Edytuj termin',
            videoConsultationWarning: {
               allOnSiteReceptionServices:
                  'Rezerwujesz wideokonsultację dla usług oznaczonych jako stacjonarne. Upewnij się, że ta wizyta może się odbyć online.',
               allVideoConsultationReceptionServices:
                  'Rezerwujesz wizytę stacjonarną dla usług o typie wideokonsultacja. Upewnij się, że ta wizyta ma się odbyć stacjonarnie.',
               mixedDeliveryModeTypes: 'Zostały dodane usługi recepcyjne o różnym typie wizyty (online i stacjonarna).',
            },
            visitAndAppointmentStatusFilter: {
               chosenOf: 'Wybrano {{count}} z {{totalCount}}',
               filterLabel: 'Status: {{statuses}}',
               filterLabelAll: 'Wszystkie',
               selectAll: 'Wybierz wszystkie',
               selectStatuses: 'Wybierz statusy wizyt',
            },
            visitEncounterModeFilter: {
               chosenOf: 'Wybrano {{count}} z {{totalCount}}',
               filterLabel: 'Typ wizyty: {{encounterModes}}',
               filterLabelAll: 'Wszystkie',
               selectAll: 'Wybierz wszystkie',
               selectEncounterModes: 'Wybierz typy wizyt',
            },
            visitEncounterModeMap: {
               ON_SITE: 'Stacjonarna',
               VIDEO_CONSULTATION: 'Wideokonsultacja',
            },
         },
         calendar: {
            actionBar: {
               goBackToVisit: 'Wróć do wizyty',
            },
            addVisitDurationInSchedulePanel: 'Dodaj długość wizyty w harmonogramie',
            appointmentContextDialog: {
               patientFetchError: 'Nie udało się pobrać danych pacjenta. Spróbuj ponownie później.',
               tabs: {
                  appointmentDetailsTab: {
                     advancePayments: {
                        actions: {
                           label: 'Zwróć przedpłatę',
                        },
                        advancePayment: 'Przedpłata',
                        advancePaymentMethodWithDescription: '{{methodType}} ({{description}})',
                        header: 'Kwota opłacona',
                        methodMap: {
                           BANK_TRANSFER: 'przelew',
                           CASH: 'gotówka',
                           ONLINE_PAYMENT: 'płatność online',
                           OTHER: 'inna',
                           PAYMENT_CARD: 'karta płatnicza',
                        },
                        methodTextView: '(przedpłata), {{advancePaymentMethod}}',
                     },
                     appointmentConfirmationStatus: 'Status potwierdzenia',
                     appointmentSource: {
                        docplanner: 'Rezerwacja przez portal ZnanyLekarz',
                        patientPortal: 'Rezerwacja przez portal drEryk Pacjent',
                     },
                     bookingPersonWithDate: 'Osoba rejestrująca, dnia {{creationDate}} o godz. {{creationTime}}',
                     cancellationAt: 'Wizyta odwołana {{cancellationDate}} o {{cancellationTime}}',
                     cancellationBy: 'przez {{cancellationBy}}',
                     cancellationByExternalSourceLabelMap: {
                        ZnanyLekarz: 'portal ZnanyLekarz',
                        egabinet: 'system eGabinet',
                        'patient-portal': 'portal drEryk Pacjent',
                        'patient-sms': 'SMS',
                     },
                     cancellationByUnknownExternalSource: 'zewnętrzny system',
                     confirmed: 'Potwierdzona',
                     contactToPatient: 'Kontakt do pacjenta',
                     copyLink: 'Skopiuj link',
                     creationDateTime: 'Dnia {{creationDate}} o godz. {{creationTime}}',
                     encounterMode: 'Typ wizyty',
                     encounterModeMap: {
                        ON_SITE: 'Wizyta stacjonarna',
                        VIDEO_CONSULTATION: 'Wideokonsultacja',
                     },
                     inWaitingRoom: 'W poczekalni',
                     label: 'Szczegóły wizyty',
                     loader: {
                        fetchError: 'Nie udało się załadować danych. Spróbuj ponownie później.',
                     },
                     noContactToPatient: 'Brak podanego numeru',
                     notConfirmed: 'Niepotwierdzona',
                     notSpecified: 'Nieokreślony',
                     noteHeader: 'Notatka do wizyty',
                     patientAge: {
                        yearsAccusative: 'rok',
                        yearsGenitive: 'lata',
                        yearsPlural: 'lat',
                     },
                     presenceStatus: 'Status obecności',
                     timeSlotNotConfirmedWarning: 'Ta wizyta została dodana bez potwierdzenia terminu z pacjentem.',
                     unknownPatient: 'Pacjent nie ma uzupełnionej kartoteki',
                     visitConductor: 'Osoba przeprowadzająca wizytę',
                  },
               },
            },
            bookNextVisitForPatient: 'Zarezerwuj kolejną wizytę dla pacjenta:',
            calendar: 'Kalendarz',
            calendarPreferences: 'Preferencje kalendarza',
            cancel: 'Odwołaj',
            failedToFetchSpecialists: 'Nie udało się pobrać dostępnych specjalistów.',
            goBackToCalendar: 'Wróć do kalendarza',
            guardianPesel: 'PESEL opiekuna: {{guardianPesel}}',
            nextAvailableTimeSlot: 'Następny wolny termin',
            noAvailableTimeSlots: 'Brak wolnych terminów. Dodaj nowe w harmonogramie.',
            noScheduleNorVisits: 'Brak harmonogramu oraz wizyt',
            noScheduleNorVisitsInView: 'W widocznym zakresie nie ma zdefiniowanego harmonogramu oraz wizyt poza nim.',
            passport: 'Paszport: {{passport}}',
            pesel: 'PESEL: {{pesel}}',
            pinue: 'PIN UE: {{nationalIdentificationNumber}}',
            practitioner: {
               noSpecialties: 'brak specjalizacji',
               paramedicalProfessions: {
                  ADDICTION_PSYCHOTHERAPY_SPECIALIST: 'Specjalista psychoterapii uzależnień',
                  DIETITIAN: 'Dietetyk',
                  OTHER: 'Inny',
                  PSYCHOLOGIST: 'Psycholog',
                  PSYCHOTHERAPIST: 'Psychoterapeuta',
               },
            },
            preferScheduleAndOffScheduleVisits: 'Pokazuj zakres harmonogramu oraz wizyty spoza harmonogramu',
            save: 'Zapisz',
            sidePanel: {
               calendarModeButtonGroup: {
                  items: {
                     healthcareLocation: 'Placówka',
                     specialist: 'Specjalista',
                  },
               },
               heading: 'Kalendarz',
            },

            turnOffPreferences: 'Wyłącz ograniczenie widoku',

            waitlist: 'Lista rezerwowa',
            waitlistEntry: {
               anyLocation: 'Dowolna placówka',
               datePreferences: 'Preferencje dot. terminu:',
               encounterMode: 'Typ wizyty',
               encounterModeMap: {
                  ON_SITE: 'Stacjonarna',
                  VIDEO_CONSULTATION: 'Wideokonsultacja',
               },
               noRestrictions: 'bez ograniczeń',
               notSelected: 'nie wybrano',
               note: 'Notatka',
               phoneAbbreviation: 'tel. {{phoneNumber}}',
               preference: 'Preferencja: {{label}}',
               preferredDate: 'Pref. termin',
               priorityLabelled: 'Priorytet: {{label}}',
               priorityPreference: 'Priorytetowa preferencja: {{label}}',
               prioritySuffix: '- priorytet',
               reservationPreferenceMap: {
                  LOCATION: 'Lokalizacja',
                  PRACTITIONER: 'Specjalista',
                  TIME: 'Termin',
               },
               scheduleAppointmentFor: 'Wyznacz termin dla:',
               service: 'Usługa',
               serviceProvidingLocationAbbreviation: 'MUŚ',
               specialist: 'Specjalista',
               successfullyCreatedNewAppointment: 'Pomyślnie zarezerwowano wizytę.',
               successfullyCreatedNewAppointmentAndChangedEntryStatus:
                  'Pomyślnie zarezerwowano wizytę i zmieniono status wpisu na Zapisany.',
               successfullyCreatedTemporaryAppointment: 'Pomyślnie dodano rezerwację tymczasową.',
               successfullyCreatedTemporaryAppointmentAndChangedEntryStatus:
                  'Pomyślnie dodano rezerwację tymczasową i zmieniono status wpisu na Zarezerwowany.',
               timeOfDayMap: {
                  /* eslint-disable sort-keys-fix/sort-keys-fix */
                  MORNING: 'do 12:00',
                  AFTERNOON: '12:00-17:00',
                  EVENING: 'po 17:00',
                  /* eslint-enable */
               },
               urgent: 'Pilny termin',
               wholeWeek: 'Cały tydzień',
            },
         },
         common: {
            findAndReplaceMedicine: 'Znajdź i zastąp lek',
            medicineWithdrawn: 'Lek wycofany',
            medicineWithdrawnFromMarket: 'Lek wycofany ze sprzedaży. <link />',
            notApplicable: 'n/d',
         },
         confirmingVisit: 'Zatwierdzanie wizyty',
         controlsBar: {
            insertFromTemplate: 'Wstaw z szablonu',
            saveAsTemplate: 'Zapisz jako szablon',
            visitConfidentialityLevel: {
               CONFIDENTIAL: 'Poufna',
               NORMAL: 'Normalna',
            },
            visitEncounterMode: {
               ON_SITE: 'Wizyta stacjonarna',
               VIDEO_CONSULTATION: 'Wideokonsultacja',
            },
         },
         copyVideoConsultationLinkForPatient: 'Skopiuj link dla pacjenta',
         documentSigning: {
            invalidCertificateWarning: 'Nie udało się podpisać dokumentu. Spróbuj ponownie za chwilę.',
            myAccount: 'Moje konto',
            noValidPersonalCertificateWarning:
               'Nie udało się podpisać dokumentu - brak dodanego certyfikatu osobistego lub certyfikat jest nieaktualny, zaktualizuj go w <link />.',
         },
         draftSaveFail: 'Nie udało się zapisać wersji roboczej. Spróbuj ponownie.',
         /**
          * Ezla
          */
         ezla: {
            common: {
               KRUS: 'KRUS',
               NIP: 'NIP',
               OTHER_FOREIGN: 'W innym państwie',
               OTHER_POLAND: 'Innym w Polsce',
               PASSPORT_NUMBER: 'Paszport',
               PESEL: 'PESEL',
               ZUS: 'ZUS',
               allPayers: 'Wszyscy płatnicy',
               allPayersChosen: 'Wybrano wszystkich ({{count}}) płatników',
               canWalk: 'Chory może chodzić',
               chooseOneOrMorePayers: 'Wybierz jednego lub więcej płatników',
               chosenPayers: 'Wybrano {{count}} {{countBasedSuffix}}',
               city: 'Miejscowość',
               codeA: 'A',
               codeADescription:
                  'A - niezdolność do pracy powstała po przerwie nie przekraczającej 60 dni, spowodowanej tą samą chorobą sprzed przerwy',
               codeB: 'B',
               codeBDescription: 'B - niezdolność do pracy w okresie ciąży',
               codeC: 'C',
               codeCDescription: 'C - niezdolność do pracy spowodowana nadużywaniem alkoholu',
               codeD: 'D',
               codeDDescription: 'D - niezdolność do pracy spowodowana gruźlicą',
               codeE: 'E',
               codeEDescription:
                  'E - niezdolność do pracy powstała nie później niż 3 miesiące od ustania ubezpieczenia chorobowego z powodu choroby zakaźnej, której' +
                  ' okres wylęgania przekracza 14 dni lub inną chorobę, której objawy ujawniają się po okresie 14 dni od początku choroby',
               codes: 'Kod(y)',
               couldNotFetchPayers: 'Nie udało się pobrać listy płatników',
               diagnosis: 'Rozpoznanie',
               doctorData: 'Dane lekarza',
               doctorDataGetFail: 'Wystąpił błąd podczas pobierania danych lekarza.',
               documentMailingFailure: 'Nie udało się wysłać dokumentu:',
               documentSendErrors: {
                  externalSystemError: 'Błąd z systemu zewnętrznego: {{errorCode}} {{errorMessage}}',
                  externalSystemErrors: 'Błędy z systemu zewnętrznego:',
               },
               draftGetFail: 'Wystąpił błąd podczas pobierania wersji roboczej eZwolnienia.',
               draftSaveFailMessage:
                  'Nie udało się zapisać wersji roboczej eZwolnienia. Czy na pewno chcesz powrócić do widoku wizyty?',
               draftSaveFailTitle: 'Nieudany zapis wersji roboczej',
               draftSaveSuccessMessage: 'Wersja robocza eZwolnienia została zapisana.',
               enterCity: 'Uzupełnij miejscowość',
               enterStreetName: 'Uzupełnij nazwę ulicy',
               fillICD10OrDiseaseName: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
               flatNo: 'Nr mieszkania',
               hideCodesDescriptions: 'Ukryj opisy kodów',
               houseNo: 'Nr domu',
               identificationNumberType: {
                  NIP: 'NIP',
                  PASSPORT_NUMBER: 'Seria i numer paszportu',
                  PESEL: 'PESEL',
               },
               invalidDateRange: 'Data rozpoczęcia zwolnienia musi być równa lub większa niż data zakończenia',
               invalidNIP: 'Nieprawidłowy NIP',
               leaveAfterTerminationOfEmployment: 'Zwolnienie po ustaniu zatrudnienia',
               leaveDateRangeReason:
                  'Podaj uzasadnienie dla zwolnienia zaczynającego się wcześniej niż 3 dni wstecz od daty bieżącej',
               leaveDaysCount: 'Liczba dni zwolnienia',
               medicalIndications: 'Wskazania lekarskie',
               missingDoctorActiveP1CertificateFault: 'Brak ważnego certyfikatu lekarza.',
               noPuePayers: 'Brak płatników',
               payerAccusative: 'płatnika',
               payerIdentificationNumber: 'Identyfikator płatnika',
               payerIdentificationNumberLabel: '{{identificationType}}: {{identificationNumber}}',
               payerIdentificationNumberType: 'Rodzaj identyfikatora',
               payerName: 'Nazwa płatnika',
               payerNameAndIdentification: '{{name}}, {{identificationType}}: {{identificationNumber}}',
               payerNameLabel: '{{name}}, {{identificationType}}: {{identificationNumber}}',
               payersPlural: 'płatników',
               periodOfInabilityToWork: 'Okres niezdolności do pracy',
               postcode: 'Kod pocztowy',
               pueFaultWithCode: '{{errorMessage}} (kod błędu: {{errorCode}})',
               pueFaultWithCodeOnly: 'Nie udało się wysłać dokumentu. Kod błędu: {{errorCode}}',
               puePayersLoading: 'Wczytywanie listy płatników...',
               reason: 'Uzasadnienie',
               showCodesDescriptions: 'Pokaż opisy kodów',
               street: 'Ulica',
               submit: 'Wystaw eZwolnienie',
               submitError: 'Wystąpił błąd w wysyłce eZwolnienia.',
               submitSuccess: 'eZwolnienie zostało wystawione.',
               submittingMedicalLeave: 'Wysyłanie eZwolnienia',
               workInabilityData: 'Dane o niezdolności do pracy',
            },
            guardianMedicalLeaveForm: {
               addGuardian: 'Dodaj opiekuna',
               addNewGuardian: 'Dodaj nowego opiekuna',
               cannotBeDateInFuture: 'Nie może być datą w przyszłości.',
               chooseGuardian: 'Wybierz opiekuna',
               fillGuardianData: 'Wypełnij dane opiekuna, aby pobrać dane płatników',
               fillPatientDataForSearch: 'Uzupełnij nazwisko, imię, identyfikator lub numer telefonu',
               guardianAlreadyAdded: 'Opiekun o podanym identyfikatorze został już dodany',
               guardianBirthDate: 'Data urodzenia opiekuna',
               guardianData: 'Dane opiekuna',
               guardianInsuredIn: 'Opiekun ubezpieczony w:',
               guardianLeaveDateRange: 'Czas trwania zwolnienia opiekuna',
               guardianPayerData: 'Dane płatnika opiekuna',
               guardianPayersData: 'Dane płatników opiekuna',
               guardianSameAsPatient: 'Wybrany opiekun jest pacjentem',
               guardianStayAddress: 'Adres pobytu opiekuna',
               patientNotFound: 'Nie znaleziono pacjenta',
               patientRelationCode: 'Kod pokrewieństwa Pacjenta',
               phoneAbbreviation: 'tel.',
               relationCode: 'Kod pokrewieństwa pacjenta',
               /* eslint-disable camelcase */
               relationCodeDescription_CHILD: '1 - dziecko',
               relationCodeDescription_NEXT_OF_KIN:
                  '2 - małżonek, rodzice, ojczym, macocha, teściowie, dziadkowie, wnuki, rodzeństwo',
               relationCodeDescription_OTHER: '3 - inne osoby',
               relationCode_CHILD: '1 - dziecko',
               relationCode_NEXT_OF_KIN: '2 - małżonek...',
               relationCode_OTHER: '3 - inne osoby',
               save: 'Zapisz',
               /* eslint-enable camelcase */
               selectGuardianFromPatientsList: 'Wyszukaj opiekuna z listy pacjentów',
            },
            historicalLeaves: {
               actions: 'Akcje',
               creationDateTime: 'Czas utworzenia',
               daysCount: 'Dni',
               diagnosis: 'Rozp.',
               documentAuthor: 'Autor dokumentu',
               forGuardian: 'Na opiekę',
               foreignInsuredPrintModal: {
                  copyWithoutIcd10: 'Kopia (bez kodu ICD-10)',
                  originalWithIcd10: 'Oryginał (z kodem ICD-10)',
                  title: 'Drukujesz eZLA dla ubezpieczonego w innym Państwie',
                  whichDocumentTypeToPrint: 'Który rodzaj dokumentu wydrukować?',
               },
               goToEzlaForm: 'Przejdź do zakładki eZwolnienie i uzupełnij formularz',
               no: 'Nie',
               noHistoricalLeaves: 'Nie wystawiono żadnego eZwolnienia dla tego pacjenta',
               payer: 'Płatnik',
               payerAccountExists: 'Płatnik posiada konto PUE ZUS',
               payerAccountNotExists: 'Płatnik nie posiada konta PUE ZUS',
               payerPueAccount: 'PUE',
               periodOfValidity: 'Okres obowiązywania',
               print: 'Drukuj',
               printError: 'Nie udało się wydrukować eZwolnienia.',
               serialNumber: 'Seria i numer',
               yes: 'Tak',
            },
            identityDocument: {
               passport: {
                  edit: {
                     button: {
                        label: 'Edytuj paszport',
                     },
                     modal: {
                        basicTitle: 'Edytuj dokument potwierdzający tożsamość',
                        documentNotValidTitle: 'Dokument potwierdzający tożsamość stracił ważność',
                        saveAction: {
                           identityDocumentUpdated: 'Dokument potwierdzający tożsamość został zaktualizowany.',
                           label: 'Zapisz',
                        },
                     },
                  },
                  enter: {
                     button: {
                        label: 'Dodaj paszport',
                     },
                     modal: {
                        saveAction: {
                           identityDocumentUpdated: 'Dokument potwierdzający tożsamość został zaktualizowany.',
                           label: 'Zapisz',
                        },
                        title: 'Dodaj dokument potwierdzający tożsamość',
                     },
                     overrideMonit:
                        'Dodany paszport zastąpi wcześniej wprowadzone dane innego dokumentu potwierdzającego tożsamość.',
                  },
                  passportCountry: {
                     label: 'Kraj wydania paszportu',
                  },
                  passportValidTo: {
                     label: 'Data ważności',
                     validate: {
                        cannotBeDateInPast: 'Nie może być datą w przeszłości.',
                     },
                  },
               },
               type: {
                  displayName: {
                     PASSPORT: 'Paszport',
                  },
                  label: 'Rodzaj dokumentu',
                  selectItemName: {
                     Passport: 'Paszport',
                  },
               },
               value: {
                  label: 'Seria i numer',
                  validate: {
                     invalidPassport: 'Niepoprawny paszport',
                  },
               },
            },
            medicalLeaveForm: {
               fillPatientData: 'Wypełnij dane pacjenta, aby pobrać dane płatników',
               insuredIn: 'Ubezpieczony w:',
               medicalLeaveDateRange: 'Czas trwania zwolnienia',
               patientData: 'Dane pacjenta',
               patientName: '{{firstName}} {{lastName}}',
               patientStayAddress: 'Adres pobytu pacjenta',
               payerData: 'Dane płatnika',
               payersData: 'Dane płatników',
               pueNotAvailable: 'System PUE ZUS jest niedostępny. Spróbuj ponownie za chwilę.',
            },
            personalData: {
               identifierType: {
                  displayName: {
                     Passport: 'Paszport',
                     Pesel: 'PESEL',
                  },
                  label: 'Typ identyfikatora',
                  typeName: {
                     Passport: 'Paszport',
                     Pesel: 'PESEL',
                  },
               },
               identifierValue: {
                  label: 'Identyfikator',
                  placeholder: {
                     Passport: 'seria i numer paszportu',
                     Pesel: '',
                  },
                  validate: {
                     invalidPassport: 'Niepoprawny paszport',
                     invalidPassportPattern: 'Nie może zawierać białych znaków',
                     invalidPesel: 'Niepoprawny numer PESEL',
                  },
               },
               passportCountry: {
                  label: 'Kraj wydania paszportu',
               },
               passportValidTo: {
                  label: 'Data ważności',
                  placeholder: 'dd.mm.rrrr',
                  validate: {
                     cannotBeDateInPast: 'Nie może być datą w przeszłości.',
                  },
               },
            },
            tabs: {
               guardianMedicalLeave: 'eZwolnienie dla opiekuna',
               historicalLeaves: 'Historia zwolnień',
               medicalLeave: 'eZwolnienie',
            },
         },
         goBackToAppointmentsList: 'Wróć do listy wizyt',
         goBackToPrescriptionVisit: 'Wróć do wizyty receptowej',
         goBackToVisit: 'Wróć do wizyty',
         goBackToVisitFromVideoCall: 'Wróć do wizyty z wideokonsultacji',
         goBackToVisitHistory: 'Wróć do historii pacjenta',
         invalidTransition: 'Wizyta już została rozpoczęta',
         medicalEvents: {
            status: {
               ERROR: 'Błąd rejestracji Zdarzenia Medycznego - {{errorMessage}}',
               OUTDATED: 'Przedawnione Zdarzenie Medyczne - {{errorMessage}}',
               PENDING: 'Oczekujące Zdarzenie Medyczne',
               REGISTERED: 'Zarejestrowane Zdarzenie Medyczne',
            },
         },
         /**
          * Nfz
          */
         nfz: {
            error: 'Nie udało się pobrać oddziałów NFZ',
            fetching: 'Pobieranie oddziałów NFZ',
            nfzAgreementInformation: {
               modalTitle: 'Dane umowy',
               nfzSelectorLabel: 'Wybierz oddział NFZ, z którym podpisano umowę',
               onSuccessMessage: 'W danych placówki zapisano wskazany oddział NFZ.',
            },
         },

         patient: {
            noSpecialties: 'brak specjalizacji',
            patient: 'Pacjent',
            patientNotFound: 'Nie znaleziono pacjenta',
            searchPlaceholder: 'Wpisz nazwisko, imię, identyfikator, numer telefonu lub nazwę oznaczenia...',
         },

         /* eslint-disable camelcase */
         patientDetails: {
            age: 'Wiek',
            phoneAbbreviation: 'tel.',
            phoneAbbreviationUppercase: 'Tel',
         },

         patientVisits: 'Wizyty pacjenta',

         pregnancyStatus: {
            choose: 'Wybierz',
            completionType: 'Sposób zakończenia ciąży',
            determinedOnBasis: 'Wyznaczona na podstawie',
            gynecologicalInterview: 'Wywiad ginekologiczny',
            markPatientPregnancy: 'Oznacz pacjentkę w ciąży',
            markPatientPregnancyAndSendToP1: 'Oznacz i wyślij do P1',
            markPregnancyCompletion: 'Oznacz zakończenie ciąży',
            markPregnancyCompletionAndSendToP1: 'Oznacz i wyślij do P1',
            markingPregnancy: 'Oznaczenie pacjentki w ciąży',
            multiplePregnancy: 'ciąża mnoga',
            patientPregnant: 'Pacjentka w ciąży',
            predictedCompletionDate: 'Przewidywana data porodu',
            predictedCompletionDateBasis: {
               EXAMINATION: 'Badania',
               LAST_MENSTRUATION: 'Ostatniej menstruacji',
               LAST_OVULATION: 'Ostatniej owulacji',
            },
            pregnancy: 'Ciąża',
            pregnancyCompletion: 'Zakończenie ciąży',
            pregnancyCompletionDate: 'Data zakończenia ciąży',
            pregnancyCompletionMarkedSuccessfully: 'Oznaczono zakończenie ciąży.',
            pregnancyCompletionMarkedSuccessfullyWithMedicalEvent:
               'Oznaczono zakończenie ciąży i zarejestrowano Zdarzenie Medyczne.',
            pregnancyCompletionType: {
               DEAD_DELIVERY: 'Poród martwy',
               DELIVERY: 'Poród',
               MISCARRIAGE: 'Poronienie',
               OTHER: 'Inny powód zakończenia ciąży',
            },
            pregnancyConfirmed: 'potwierdzona',
            pregnancyMarkedSuccessfully: 'Oznaczono pacjentkę jako pacjentkę w ciąży.',
            pregnancyMarkedSuccessfullyWithMedicalEvent:
               'Oznaczono pacjentkę jako pacjentkę w ciąży i zarejestrowano Zdarzenie Medyczne.',
            pregnancyUnconfirmed: 'niepotwierdzona',
            shouldMarkPregnancy: 'Czy oznaczyć pacjentkę jako pacjentkę w ciąży i zaraportować Zdarzenie Medyczne?',
            shouldMarkPregnancyCompletion: 'Czy oznaczyć zakończenie ciąży i zaraportować Zdarzenie Medyczne?',
            visitSidePanelPatientPregnancyDateDescription:
               'Przewidywana data porodu: {{predictedCompletionDate}}, wyznaczona na podstawie: {{predictedCompletionBasis}}',
         },
         prescription: {
            addToPrescription: 'Dodaj do eRecepty',
            continuouslyUsedMedicines: 'Leki stałe',
            noResultsLabel: 'Brak leków stałych',
            removeFromPrescription: 'Usuń z eRecepty',
         },
         prescriptionVisitTemplates: {
            diagnosis: 'Rozpoznanie (ICD-10)',
            medicalService: 'Usługa rozliczeniowa',
            privateMedicalServices: 'Usługi prywatne',
            procedure: 'Procedury medyczne',
            receptionService: 'Usługa recepcyjna',
            save: 'Zapisz',
            saveFailure: 'Nie udało się zapisać szablonu wizyty receptowej. Spróbuj ponownie.',
            savePartialSuccess: 'Zapisano tylko część szablonu wizyty receptowej. Spróbuj ponownie.',
            saveSuccess: 'Szablon wizyty receptowej został zapisany.',
            sectionGeneral: 'Dane podstawowe',
         },

         prescriptionVisits: {
            accountPartiallyBlocked:
               'Twoje konto zostało częściowo zablokowane z powodu nieopłaconej w terminie faktury - opłać fakturę i skontaktuj się z działem sprzedaży.',
            addPrescriptionVisit: 'Dodaj wizytę receptową',
            cancel: 'Anuluj',
            cancelPlannedAppointment: 'Odwołaj',
            cancellingIsNotPossibleInOrganization:
               'Nie można anulować wizyty, podczas której wystawiono dokument lub która została zrealizowana przez innego specjalistę.',
            cancellingIsNotPossibleInPractice: 'Nie można anulować wizyty, podczas której wystawiono dokument',
            cannotCancelReopenedVisit: 'Nie można anulować wizyty, która została ponownie otwarta.',
            cannotCancelVisitWhenChronicDiseaseExists:
               'Nie można anulować wizyty, podczas której wystawiono dokument lub stwierdzono rozpoznanie przewlekłe.',
            datetime: 'Data',
            entitlementToMedicalService: 'eWUŚ',
            form: {
               date: 'Data',
               healthcareProviderLocation: 'Miejsce Udzielania Świadczeń',
               note: 'Notatka do wizyty',
               patient: 'Pacjent',
               practitioner: 'Specjalista',
               receptionService: 'Usługa recepcyjna',
               register: 'Zarejestruj',
            },
            goBackToPrescriptionVisits: 'Wróć do listy wizyt receptowych',
            invoice: 'Faktura',
            medicalEvents: 'ZM',
            noVisits: {
               noResults: 'Brak wyników spełniających kryteria wyszukiwania',
               noVisits: 'Brak wizyt receptowych',
            },
            options: 'Opcje',
            patient: 'Pacjent',
            patientHistory: 'Historia pacjenta',
            refundAdvancePayment: 'Zwróć przedpłatę',
            reopenVisit: 'Otwórz ponownie',
            restore: 'Zaplanuj ponownie',
            settlement: {
               advancePayment: 'Przedpłata',
               label: 'Rozliczenie',
               statusDescriptionMap: {
                  SETTLED_CORRECTLY: 'Płatność rozliczona',
                  SETTLED_INCORRECTLY: 'Płatność rozliczona nieprawidłowo',
                  SETTLED_WITHOUT_MEDICAL_SERVICES: 'Płatność rozliczona bez usług',
                  UNSETTLED: 'Płatność nierozliczona',
               },
            },
            settlementServiceUnavailable: 'Usługa rozliczeniowa jest w tej chwili niedostępna.',
            specialist: 'Specjalista',
            status: 'Status wizyty',
            successfullyCancelledVisit: 'Pomyślnie anulowano wizytę - w każdym momencie możesz ją zaplanować ponownie.',
            title: 'Wizyty receptowe',
         },

         /**
          * Prescriptions
          */
         prescriptions: {
            draftPrescriptions: {
               addNfzDepartmentOrChangeReimbursement:
                  'eRecepta nie może zostać wysłana. Dodaj oddział w panelu "Moje konto" lub zmień odpłatność na 100%.',
               additionalEntitlementDocuments: 'Dokumenty uprawnień dodatkowych',
               additionalEntitlementDocumentsDataWasSaved: 'Dane dokumentów uprawnień dodatkowych zostały zapisane.',
               allPrescriptionsIssued: 'Wszystkie eRecepty wystawione.',
               areYouSureSendingPrescriptionWithReimbursement: 'Czy mimo to chcesz wystawić eReceptę refundowaną?',
               atLeastOneMedicineRequiresPatientInPersonExamination:
                  'Przynajmniej jeden lek z pakietu powinien być wystawiony po osobistym zbadaniu pacjenta. Czy potwierdzasz, że <bold>recepta została poprzedzona badaniem osobistym pacjenta i chcesz ją wysłać</bold>?',
               backToPrescriptions: 'Wróć do widoku eRecept',
               branchReimbursementAgreementSignedHasNotBeenSelected: 'Brak dodanego oddziału NFZ w panelu "Moje konto"',
               cannotSaveDraftPrescriptions:
                  'Nie udało się zapisać wersji roboczej pakietu recept. Sprawdź połączenie z Internetem.',
               certificateErrorOccurred: 'Wystąpił problem z certyfikatem placówki.',
               chooseReimbursement: 'Wybierz poziom odpłatności',
               confirmChangesAndSend: 'Potwierdź zmiany i wyślij eReceptę',
               draftSaved: 'Zapisano wersję roboczą danych z eRecepty.',
               entitlement: 'Uprawnienie',
               entitlementDocuments: 'Dokumenty uprawnień',
               errorOccurredDuringIssuingPrescription: 'Błąd - zobacz szczegóły',
               errorOccurredDuringSavingDraftMessageMessage:
                  'Nie mogliśmy zapisać danych eRecepty, czy chcesz przejść dalej? \nNiezapisane dane zostaną utracone.',
               errorOccurredDuringSavingDraftMessageTitle: 'Błąd zapisu wersji roboczej eRecepty',
               failedToFetchNfzDepartments: 'Nie udało się pobrać oddziałów NFZ',
               fetchingNfzDepartments: 'Pobieranie oddziałów NFZ.',
               fillHere: 'uzupełnić tutaj',
               fillPatientAddressData: 'Uzupełnij dane adresowe pacjenta',
               inPersonExaminationConfirm: 'Potwierdzam zbadanie pacjenta',
               informationFromEligibilityDocumentsRequiredToUseRefund:
                  'Do skorzystania z refundacji wymagane są informacje z dokumentów potwierdzających uprawnienie.',
               medicineName: 'Nazwa leku',
               medicineParametersChanged: 'Zmieniły się parametry leku',
               missingDoctorActiveP1CertificateFault: 'Brak ważnego certyfikatu lekarza.',
               missingHealthCareInstitutionActiveP1CertificatesFault:
                  'Brak ważnych certyfikatów placówki lub rozbieżność numeru księgi rejestrowej z zapisanymi certyfikatami.',
               missingNfzDepartment: 'Brak dodanego oddziału NFZ',
               nfzData: 'Dane NFZ',
               nfzDepartment: 'Oddział NFZ',
               noMedicineSelected: 'Nie dodano żadnego leku',
               noMedicineSelectedAdditionalText:
                  'Uzupełnij nazwę leku w wyszukiwarce i wybierz jedną z podpowiedzi, bądź dodaj lek z listy ostatnio wybieranych.',
               partPrescriptionsIssued: 'Część eRecept nie została wystawiona. Sprawdź szczegóły na liście eRecept.',
               patientAddressSuccessfullyUpdated: 'Dane adresowe pacjenta zostały zaktualizowane.',
               patientHasIncompleteAddress: 'Pacjent nie ma uzupełnionego adresu, możesz go <link />.',
               patientInPersonExaminationRequired:
                  'Wypisanie recepty na ten lek wymaga potwierdzenia, że wypisanie jej zostało poprzedzone badaniem osobistym pacjenta.',
               patientNoConfirmedEligibilityBenefitsMultiple:
                  'Pacjent nie ma potwierdzonego uprawnienia do świadczeń potrzebnego do otrzymania refundacji na poniższe leki:',
               patientNoConfirmedEligibilityBenefitsSingle:
                  'Pacjent nie ma potwierdzonego uprawnienia do świadczeń potrzebnego do otrzymania refundacji <bold>{{reimbursement}}</bold> dla leku <bold>{{medicineName}}</bold>. Czy mimo to chcesz wystawić eReceptę refundowaną?',
               patientNotEligibleForReimbursementMultiple:
                  'Pacjent nie ma dodanego rozpoznania lub uprawnienia dodatkowego potrzebnego do otrzymania refundacji na poniższe leki:',
               patientNotEligibleForReimbursementSingle:
                  'Pacjent nie ma dodanego rozpoznania lub uprawnienia dodatkowego potrzebnego do otrzymania refundacji <bold>{{reimbursement}}</bold> dla leku <bold>{{medicineName}}</bold>. Czy mimo to chcesz wystawić eReceptę refundowaną?',
               placePrescription: 'Wystaw eReceptę ({{count}})',
               prescriptioNCantBeSentWithoutDocumentConfirmingEntitlements:
                  'eRecepta nie może zostać wysłana. Brakuje dokumentu potwierdzającego uprawnienia {{entitlementTypes}}.',
               prescriptionCantBeSentWithoutDocumentConfirmingEntitlement:
                  'eRecepta nie może zostać wysłana. Brakuje dokumentu potwierdzającego uprawnienie {{entitlementType}}.',
               prescriptionPackageDeferredResultFault:
                  'Wysyłanie w trybie asynchronicznym niewspierane. Spróbuj wystawić mniej eRecept w pojedynczej próbie.',
               prescriptionRequirePatientInPersonExamination: 'Recepty wymagają badania osobistego',
               prescriptionType: {
                  PRO_AUCTORE: 'Pro auctore',
                  PRO_FAMILIA: 'Pro familia',
                  STANDARD: 'Zwykła',
                  select: {
                     PRO_AUCTORE: 'Recepty pro auctore',
                     PRO_FAMILIA: 'Recepty pro familia',
                     STANDARD: 'Recepty zwykłe',
                  },
               },
               prescriptionsNotIssued:
                  'eRecepty nie zostały wystawione z powodu błędu. Sprawdź szczegóły na liście eRecept.',
               reimbursement: 'Refundacja',
               reimbursementIndication: {
                  active: '(aktywne)',
                  chosenOnTheVisit: '(wybrane na wizycie)',
                  statutorilyDesignatedFreeEntitlements: {
                     C: 'C - Ciąża',
                     DZ: 'DZ - Dziecko',
                     S: 'S - Senior',
                  },
               },
               reimbursements: {
                  '30%': '30%',
                  '50%': '50%',
                  B: 'Bezpłatny',
                  R: 'Ryczałt',
                  reimbursementWithEntitlements: {
                     C: 'C Ciąża',
                     DZ: 'DZ Dziecko',
                     S: 'S Senior',
                     conjunction: ' i ',
                  },
               },
               removeMedicineFromPrescription: 'Usuń lek z eRecepty',
               saveAndSend: 'Zapisz i wyślij',
               savedNfzDepartment: 'W danych placówki zapisano wskazany oddział NFZ.',
               sendPrescriptionWithoutEntitlements: 'Wyślij eReceptę bez uprawnienia',
               sendPrescriptionWithoutIndications: 'Wyślij eReceptę bez wskazań',
               sendPrescriptions: 'Wyślij eRecepty',
               sendPrescriptionsAndClose: 'Wyślij eRecepty i zamknij',
               sendPrescriptionsAndConfirmVisit: 'Wyślij eRecepty i zatwierdź wizytę',
               sendPrescriptionsWithoutEntitlements: 'Wyślij eRecepty bez uprawnienia',
               sendPrescriptionsWithoutIndications: 'Wyślij eRecepty bez wskazań',
               sendingRefundedPrescriptions: 'Wystawiasz recepty refundowane',
               submittingPrescription: 'Wysyłanie eRecepty',
               verifyMedicineParametersChanges:
                  'Zmieniły się parametry leku. Zweryfikuj, czy dalej chcesz wypisać lek ze zmienionymi parametrami.',
               yourIssuingPrescriptionWithMedicineParametersChanged:
                  'Zmieniły się parametry leku, na który wystawiasz eReceptę. Czy chcesz zaakceptować zmiany i wystawić eReceptę na ten lek?',
            },
            failedToFetchPrescriptions: 'Nie powiodło się pobranie eRecept',
            magistralDrug: {
               addToPrescription: 'Dodaj do eRecepty',
               drugForm: 'Postać leku',
               drugName: 'Nazwa',
               infoForIssuer: 'Informacja dla osoby wydającej lek',
               insertFromTemplate: 'Wstaw z szablonu',
               medicineRawMaterials: {
                  addMaterial: 'Dodaj składnik',
                  columns: {
                     excessive: 'Ex.',
                     headerTooltips: {
                        explicitOverdose: 'Świadomie przekroczona dawka substancji czynnej',
                        narcoticSubstance: 'Substancja narkotyczna',
                        quantityAbbr: 'Skrót dotyczący ilości',
                     },
                     name: 'Nazwa składnika',
                     namePlaceholder: 'Wyszukaj lub uzupełnij nazwę składnika....',
                     quantity: 'Ilość',
                     quantityAbbreviation: 'Skrót ilości',
                     rpw: 'RPW',
                     unit: 'Jedn.',
                  },
                  label: 'Składniki',
                  quantityAbbrWhenRpw: 'Nie można zmienić dla składnika RPW',
                  quantityAbbreviationPlaceholder: '-',
                  quantityRequiredIfUnitProvided: 'Pole wymagane, gdy wskazano ilość substancji.',
               },
               resetForm: 'Wyczyść wszystko',
               resetFormModal: {
                  confirmationButtonLabel: 'Wyczyść',
                  content:
                     'Czy chcesz wyczyścić formularz leku recepturowego? Dane leku niedodanego do recepty zostaną utracone.',
                  title: 'Czyścisz formularz leku recepturowego',
               },
               tabName: 'Dodaj lek recepturowy',
            },
            medicine: {
               DS: 'DS',
               DS3Chars: 'Wymagany format: YxZ (np. 1x1) lub minimum 4 znaki.',
               DSPlaceholder: '1x1 tabl. na czczo, doustnie',
               addMissingPatientEntitlementDocument: 'Dodaj dane dokumentów uprawnień dodatkowych',
               additionalEntitlementSelectLabel: 'Uprawnienia dod.',
               additionalEntitlementSelectPlaceholder: 'Wybierz',
               details: {
                  goBack: 'Wróć',
                  removeFromPrescription: 'Usuń z eRecepty',
               },
               issuedForYear: '365 dni',
               issuedFrom: 'Realizacja od: ',
               issuedTo: 'do: ',
               packet: 'op.',
               packetMaxError: 'Maks. 30',
               packetMinError: 'Min. 0.01',
               removeMedicineFromPrescription: 'Usuń lek z eRecepty',
               replacement: {
                  chooseNewMedicine: 'Wybierz nowy lek',
                  medicinesSimilar: 'Podobne leki',
                  removeWithdrawnMedicine: 'Usuń wycofany lek',
                  replaceMedicine: 'Zamień lek',
                  replaceMedicineForAll: 'Zamień u wszystkich',
                  replaceMedicineForPatient: 'Zamień u tego pacjenta',
                  replaceWithdrawnMedicineToAnotherOne: 'Zamień wycofany lek na inny',
                  searchForMedicineByTradeNameOrActiveIngredientOrICD10codePlaceholder:
                     'Szukaj leku po nazwie handlowej, substancji czynnej lub kodzie ICD-10...',
               },
               substituteForbidden: 'Nie zamieniać',
               successfullyCreatedContinuouslyUsedMedicine: 'Dodano lek do listy leków stałych.',
               successfullyDeletedContinuouslyUsedMedicine: 'Usunięto lek z listy leków stałych.',
            },
            medicineSelector: {
               addMedicineToContinuouslyUsedMedicines: 'Dodaj lek do leków stałych',
               addMedicineToPrescription: 'Dodaj lek do eRecepty',
               addPreparedMedicine: 'Dodaj lek gotowy',
               continouslyUsedMedicineModal: {
                  content: 'Czy na pewno usunąć {{medicineName}} z listy leków stałych?',
                  title: 'Usuwasz lek stały',
               },
               demoNotification:
                  'W wersji demo dostępne są tylko leki zaczynające się na literę A. Dane mogą być niepełne lub nieaktualne i mogą różnić się od wersji produkcyjnej systemu',
               input: {
                  label: 'Wyszukaj lek',
                  noMedicine: 'Brak leku',
                  placeholder: 'Szukaj leku po nazwie handlowej, substancji czynnej lub kodzie ICD-10...',
               },
               removeMedicineFromContinuouslyUsedMedicines: 'Usuń lek z leków stałych',
               safetyIndicators: {
                  applyingAllowed: 'Stosowanie dopuszczone',
                  breastFeeding: 'Karmienie piersią',
                  couldNotResolveCategory: 'nie możemy ustalić kategorii bezpieczeństwa',
                  couldNotResolveCategoryForName: 'Nie możemy ustalić kategorii bezpieczeństwa - {{name}}',
                  drivingCar: 'Prowadzenie pojazdu',
                  drivingCarSafe: 'Nie wpływa na sprawność psychomotoryczną i prowadzenie pojazdów',
                  influenceOn: 'Wpływ na: {{interactionTarget}}',
                  interactionWithAlcohol: 'Interakcja z alkoholem',
                  noAlcoholInteraction: 'Brak stwierdzonej interakcji',
                  noData: 'Brak danych',
                  pregnantFirstTrimester: 'Pierwszy trymestr',
                  pregnantSecondTrimester: 'Drugi trymestr',
                  pregnantThirdTrimester: 'Trzeci trymestr',
               },
               searchMedicinesRelatedToIcd10Code: 'Wyszukaj leki powiązane z {{icd10Code}}',
               table: {
                  addMedicineToFavorites: 'Dodaj lek do swoich ulubionych',
                  addedMedicineToFavorites: 'Dodano lek do leków ulubionych.',
                  commercialName: 'Nazwa handlowa',
                  label: 'Ostatnio wybierane dla pacjenta',
                  noContinuouslyUsedMedicines: 'Brak leków stałych',
                  noContinuouslyUsedMedicinesResults:
                     'Oznacz lek jako stały używając ikony <icon /> przy wybranym leku, aby zobaczyć go w tym miejscu.',
                  noFavoriteMedicines: 'Brak leków ulubionych',
                  noFavoriteMedicinesResults:
                     'Oznacz lek jako swój ulubiony używając ikony <heartIcon /> przy wybranym leku, aby zobaczyć go w tym miejscu.',
                  noMedicines: 'Brak leków',
                  noResults: 'Brak wyników spełniających kryteria wyszukiwania',
                  package: 'Opakowanie',
                  removeMedicineFromFavorites: 'Usuń lek ze swoich ulubionych',
                  removedMedicineFromFavorites: 'Usunięto lek z leków ulubionych. <restoreLink />',
                  removedMedicineFromFavoritesWithoutRestore: 'Usunięto lek z leków ulubionych.',
                  restore: 'Przywróć',
               },
               tabs: {
                  continuouslyUsedMedicines: 'Leki stałe',
                  favoriteMedicines: 'Leki ulubione',
                  prescriptionHistory: 'Historia recept',
               },
            },
            missingAddressForPAPF: {
               contactDetailsSaved: 'Dane zostały zapisane w panelu Moje konto.',
               missingAddressDetails: 'Brak wymaganych danych dla recept pro auctore/pro familia',
               saveAndSendPrescriptions: 'Zapisz i wyślij eRecepty',
               yourAddress: 'Twój adres zamieszkania',
               yourPhoneNumber: 'Twój numer kontaktowy',
            },
            notAcceptedPrescriptionsMessage: {
               cancel: 'Wróć do widoku eRecept',
               confirm: 'Zatwierdź',
               message:
                  'W widoku eRecepta istnieją niewysłane recepty. Czy na pewno chcesz zatwierdzić wizytę i utracić te recepty?',
               title: 'Zatwierdzenie wizyty',
            },

            prescription: {
               additionalRequirements: {
                  others: 'Inne',
                  type: {
                     CITO: 'Cito',
                     FOR_YEAR: '365 dni',
                     SUBSTITUTE_FORBIDDEN: 'Nie zamieniać',
                  },
               },
               cannotIssueForYear:
                  'Nie mamy potrzebnych danych do wystawienia tego leku na 365 dni. Możesz wystawić go w standardowej recepcie.',
               day: 'dzień',
               days: 'dni',
               dosage: {
                  DS: 'DS / Informacja dla pacjenta',
                  DS3Chars: 'Wymagany format: YxZ (np. 1x1) lub minimum 4 znaki.',
                  DSPlaceholder: 'np. 1x1 tabl. na czczo, doustnie',
                  dosage: 'Dawkowanie',
                  dosageOptional: 'Dawkowanie <optionalText>(opcjonalne)</optionalText>',
                  extendedDosage: 'Dawkowanie rozszerzone',
                  informationForPatientPlaceholder: 'np. po posiłku',
               },
               entitlements: 'Uprawnienia',
               extendedDosage: {
                  addBreak: 'Dodaj przerwę',
                  addCycle: 'Dodaj kolejny cykl',
                  administer: 'Podawaj',
                  breakHeader: 'Przerwa #{{number}} ({{days}})',
                  breakMisplaced: 'Przerwa może wystąpić tylko pomiędzy cyklami dawkowania.',
                  breakNoMedicine: 'Nie podawaj leku przez',
                  create: 'Utwórz rozszerzone',
                  cycleHeader: 'Cykl #{{number}} ({{days}})',
                  dsLabel: 'DS / Informacja dla pacjenta',
                  dsPlaceholder: 'Wpisz dodatkowe instrukcje o zażywaniu leku...',
                  duplicate: 'Powiel',
                  durationNotMultipleOfInterval: 'Okres stosowania musi być wielokrotnością liczby {{intervalAmount}}.',
                  during: 'przez',
                  edit: 'Edytuj',
                  everyDay: 'codziennie',

                  interval: 'co',
                  packagesCountExceeded:
                     'Liczba opakowań ({{packagesCount}}) przekracza maksymalną liczbę opakowań na recepcie ({{maxValue}}).',
                  packagesCountExceededTotal:
                     'Łączna liczba opakowań dla wszystkich cykli ({{packagesCount}}) przekracza maksymalną liczbę opakowań na recepcie ({{maxValue}}).',
                  portionUnit: 'Jednostka dawki',
                  remove: 'Usuń',
                  removeExtendedDosage: 'Usuń dawkowanie rozszerzone',
                  save: 'Zapisz dawkowanie',
                  stageModeFrequency: 'Częstotliwość',
                  stageModeTimesOfDay: 'Pory dnia',
                  stagesEmpty: 'Dodaj co najmniej jeden cykl dawkowania.',
                  timeOfDayMap: {
                     /* eslint-disable sort-keys-fix/sort-keys-fix */
                     MORNING: 'Rano',
                     NOON: 'W południe',
                     AFTERNOON: 'Po południu',
                     EVENING: 'Wieczorem',
                     /* eslint-enable sort-keys-fix/sort-keys-fix */
                  },
                  zeroDoseCycle: 'Cykl musi mieć dawkę większą od 0 w co najmniej jednej porze dnia.',
               },
               issueDate: {
                  enterTodayOrFutureDate: 'Wpisz datę dzisiejszą lub przyszłą',
                  issuedFrom: 'Realizacja od',
                  issuedTo: 'Realizacja do',
               },
               maxEntitlementsExceeded: 'Maks. 3 uprawnienia',
               medicineSufficientFor: 'Leku wystarczy na',
               numericalDosage: {
                  changeToPrescriptionForYear: 'Zmień na receptę 365',
                  days: 'dni',
                  dosageExceedingPackages: 'Dawkowanie przekracza dostępną liczbę dawek w wybranej liczbie opakowań.',
                  dosageFrequencyNotAllowed:
                     'Dopuszczalne częstotliwości dawkowania to 1, 2, 3, 4, 6, 8, 12 lub 24 razy na dobę.',
                  drugQuantity: 'ilość leku',
                  howOften: 'jak często',
                  treatmentDaysCount: 'Czas trwania kuracji',
                  treatmentDaysCountExceeded:
                     'Czas trwania kuracji przekracza {{maxValue}} dni. Taka kuracja może być wystawiona wyłącznie na recepcie rocznej (365). <link />',
                  treatmentDaysCountExceededWithoutAction: 'Czas trwania kuracji przekracza {{maxValue}} dni',
                  treatmentDaysCountNotReported:
                     'Dla tego typu recepty czas trwania kuracji nie jest wymagany i nie zostanie przekazany do P1.',
                  treatmentDaysCountRequired: 'Czas trwania kuracji jest wymagany dla tej recepty.',
               },
               prescriptionCategory: 'Typ recepty',
               print: 'Drukuj',
               quantity: {
                  quantity: 'Opak.',
               },
               quantityOfActiveIngredients: 'Ilość substancji czynnej',
            },
            prescriptionHistoryDownloadVerification: {
               goToPrescriptionsHistoryDownload: 'Przejdź do historii recept',
               prescriptionForJuvenileVerification:
                  'Wybrano uprawnienie DZ-Dziecko, które wymaga weryfikacji historii recept.',
               prescriptionForSeniorVerification:
                  'Wybrano uprawnienie S-Senior, które wymaga weryfikacji historii recept.',
               verifyPatientPrescriptionsHistory: 'Zweryfikuj historię recept pacjenta',
            },
            prescriptionHistoryPanel: {
               copyPrescription: 'Kopiuj receptę',
               filters: {
                  onlyContinuouslyUsed: 'Tylko stałe',
                  onlyMine: 'Tylko moje',
               },
            },
            quantityAbbreviation: {
               // eslint-disable-next-line id-length
               A: 'a',
               AD: 'ad',
               ANA_PARTES_AEQUALES: 'aa',
               ANA_PARTES_AEQUALES_AD: 'aa ad',
               QUANTUM_SATIS: 'q. s.',
            },
            quantityUnitShortcut: {
               AMPOULES: 'amp.',
               DROPS: 'gtt.',
               GRAMS: 'g',
               MEASURE_UNITS: 'j.m.',
               MICROGRAMS: 'mcg',
               MILLIGRAMS: 'mg',
               MILLILITRES: 'ml',
               NONE: '-',
               PIECES: 'szt.',
            },
            reimbursements: {
               B: 'B - bezpłatny',
               FULL: '100%',
               HALF: '50%',
               R: 'R - ryczałt',
               THIRTY_PERCENT: '30%',
            },
            sentPrescriptionPackages: {
               annulledPrescriptions: {
                  annulled: 'Usunięta',
                  prescriptionAnnulled: 'eRecepta została usunięta.',
                  prescriptionNotAnnulled: 'eRecepta nie została usunięta. Sprawdź szczegóły na liście eRecept.',
                  prescriptionsAnnulled: 'eRecepty usunięte',
               },
               issuedPrescriptions: 'eRecepty wystawione',
               options: {
                  annul: {
                     blockingOperation: 'Usuwanie eRecepty',
                     confirmationContent:
                        'Czy chcesz usunąć eReceptę? Zostanie wysłany dokument anulujący eReceptę i nie będzie można jej zrealizować.',
                     title: 'Usuwasz eReceptę',
                  },
               },
               packageNumber: 'Pakiet #{{packageNumber}}',
               prescriptionIssuedWithAccessCode: 'Recepta wystawiona. Kod dostępu: {{accessCode}}',
               prescriptionIssuedWithoutAccessCode: 'Recepta wystawiona. Brak kodu dostępowego.',
            },
            templates: {
               extendedDosage: {
                  areYouSureUsingTemplate:
                     'W panelu jest już ustawione dawkowanie rozszerzone. <strong>Czy chcesz użyć szablonu i nadpisać dotychczasowe dawkowanie?</strong>',
                  extendedDosageTemplates: 'Szablony dawkowania rozszerzonego',
                  insertFromTemplate: 'Wstaw z szablonu',
                  name: 'Nazwa',
                  noTemplatesAddedYet: 'Nie dodano jeszcze żadnego szablonu dawkowania rozszerzonego.',
                  portionUnitPlaceholder: 'jedn.',
                  removingTemplate: 'Usuwasz szablon dawkowania rozszerzonego',
                  saveTemplate: 'Zapisz szablon',
                  searchTemplate: 'Wyszukaj szablon po nazwie...',
                  templateName: 'Nazwa szablonu',
                  templateRemovedSuccessfully: 'Szablon został usunięty.',
               },
               magistralDrug: {
                  additionalInformation: 'Informacje dla osoby wydającej lek',
                  areYouSureUsingTemplate:
                     'W formularzu leku recepturowego były wprowadzone jakieś zmiany. <strong>Czy chcesz użyć szablonu i nadpisać wcześniej wprowadzone dane do formularza?</strong>',
                  drugForm: 'Postać leku',
                  magistralDrugTemplates: 'Szablony leków recepturowych',
                  name: 'Nazwa',
                  noInformation: 'Brak informacji',
                  noSearchResults: 'Brak pasujących szablonów',
                  noTemplates: 'Brak szablonów',
                  noTemplatesAddedYet: 'Nie dodano jeszcze żadnego szablonu leku recepturowego.',
                  rawMaterialsTable: {
                     excessive: 'Ex.',
                     ingredientName: 'Składnik',
                     quantity: 'Ilość',
                     quantityAbbreviation: 'Skrót ilości',
                     rpw: 'RPW',
                     unit: 'Jedn.',
                  },
                  removingTemplate: 'Usuwasz szablon leku',
                  searchTemplate: 'Wyszukaj szablon po nazwie lub składniku...',
                  templateName: 'Nazwa szablonu',
                  templateNameOccupied: 'Szablon o takiej nazwie już istnieje.',
                  templateRemovedSuccessfully: 'Usunięto szablon leku recepturowego.',
                  templateUsed: 'Użyto szablonu leku recepturowego.',
               },
            },
         },

         previousServiceProvidingLocationNotAvailableNewHasBeenChosen:
            'Wybrane zostało nowe miejsce udzielania świadczeń, poprzednie jest niedostępne. Sprawdź, czy jest poprawne.',
         routeChangingGuard: {
            label: 'Synchronizacja wizyty',
         },
         /* eslint-enable */
         savingVisit: 'Zapisywanie wizyty',
         serviceProvidingLocation: 'Miejsce Udzielania świadczeń',
         sidePanel: {
            aiAssistant: {
               tabLabel: 'Transkrypcja',
            },
            historicalVisits: {
               confidentialAccess: {
                  pending: 'Wysłano prośbę o dostęp',
                  request: 'Poproś o dostęp',
                  requestSuccess: 'Prośba o dostęp do wizyty poufnej została wysłana.',
                  selfGrantSuccess: 'Dostęp do wizyty poufnej został przyznany.',
               },
               diagnosis: 'Rozpoznanie ({{count}})',
               goToPatientVisitHistory: 'Przejdź do historii pacjenta',
               historicalVisit: {
                  DS: 'DS:',
                  chronic: '(przewlekły)',
                  copyIcons: {
                     all: 'Kopiuj dane z wizyty',
                     diagnoses: 'Kopiuj rozpoznanie',
                     interview: 'Kopiuj wywiad',
                     medicine: 'Kopiuj lek',
                     prescriptions: 'Kopiuj receptę',
                     recommendations: 'Kopiuj zalecenia',
                     subjectiveAssessment: 'Kopiuj badanie przedmiotowe',
                  },
                  copyPrescription: {
                     chooseReplacement: 'Wybierz podobny lek',
                     close: 'Zamknij',
                     columnMedicineName: 'Nazwa handlowa',
                     columnResult: 'Rezultat',
                     copied: 'Skopiowano',
                     copyError: 'Nie udało się skopiować recepty',
                     copySummaryDescription:
                        'Niektóre leki zostały wycofane z obrotu i nie mogą zostać skopiowane. Wybierz podobny lek z listy lub zamknij okno, aby pominąć.',
                     copySummaryTitle: 'Podsumowanie kopiowania recept',
                     medicineCopiedSuccessfully: 'Lek został pomyślnie skopiowany',
                     medicineReplacedSuccessfully: 'Lek został pomyślnie zamieniony',
                     medicinesCopiedSuccessfully: 'Recepty zostały pomyślnie skopiowane',
                     replacementError: 'Nie udało się zamienić leku',
                     replacementModalTitle: 'Zamiana wycofanego leku',
                     skipCopyingThisMedicine: 'Pomiń kopiowanie tego leku',
                     useNewMedicine: 'Skopiuj wybrany lek',
                  },
                  diagnoses: 'Rozpoznanie ({{count}})',
                  dischargeSummary: 'Informacja dla lekarza kierującego',
                  electronicDocuments: 'eDokumenty ({{count}})',
                  electronicReferralItem: 'eSkierowanie do {{type}}. KOD: {{code}}',
                  electronicReferralNoCode: 'Brak kodu dostępowego',
                  electronicReferralType: {
                     ANALYTICAL_EXAMINATION: 'laboratorium',
                     DIAGNOSTIC_EXAMINATION: 'pracowni diagnostycznej',
                     HOSPITAL: 'szpitala',
                     PSYCHIATRIC_HOSPITAL: 'szpitala psychiatrycznego',
                     REHABILITATION: 'rehabilistację',
                     SPECIALIST: 'specjalisty',
                  },
                  goBackToList: 'Wróć do historii wizyt',
                  header: 'Wizyta z dn. {{date}}',
                  interview: 'Wywiad',
                  leaveIssuedForDatePeriod: 'eZwolnienie za okres:',
                  loading: 'Ładowanie...',
                  medicalCertificate: 'Zaświadczenie lekarskie',
                  medicalLeaves: 'eZwolnienia ({{count}})',
                  medicineCopied: 'Lek {{medicineName}} został skopiowany',
                  medicinesCopied: 'Leki {{medicineNames}} zostały skopiowane',
                  noElectronicDocumentsIssued: 'Nie wystawiono żadnych eDokumentów',
                  noLeavesIssued: 'Nie wystawiono eZwolnienia',
                  noPrescriptionIssued: 'Nie wystawiono żadnych eRecept',
                  noPrints: 'Nie wygenerowano żadnych druków',
                  noVisitData: 'Brak danych wizyty',
                  package: 'opak. ',
                  prescriptionCompletionDateFrom: 'Data realizacji od: ',
                  prescriptionCompletionDateTo: 'Data realizacji do: ',
                  prescriptions: 'eRecepty ({{count}})',
                  prints: 'Druki ({{count}})',
                  recommendations: 'Zalecenia',
                  removed: 'Usunięta',
                  showVisit: 'Podgląd wizyty',
                  subjectiveAssessment: 'Badanie przedmiotowe',
               },
               noVisits: 'Ten pacjent nie odbył jeszcze żadnej wizyty',
               prescribedMedicines: 'Przepisane leki ({{count}})',
               visitsHistory: 'Historia wizyt',
            },
            medicalData: {
               categories: {
                  ALLERGY: 'Uczulenia',
                  ANALYTICAL_TEST_RESULT: 'Wyniki badań analitycznych',
                  ANTHROPOMETRY: 'Antropometria',
                  CHRONIC_DISEASE: 'Choroby przewlekłe',
                  DIAGNOSIS: 'Rozpoznania',
                  GYNECOLOGICAL_INTERVIEW: 'Wywiad ginekologiczny',
                  HOSPITALIZATION: 'Hospitalizacje',
                  MEDICAL_CONSULTATION: 'Konsultacje medyczne',
                  MEDICAL_IMAGING: 'Wyniki badań obrazowych',
                  OTHER: 'Inne',
                  REFERRAL: 'Skierowanie',
                  REHABILITATION: 'Rehabilitacje',
                  RISK_FACTOR: 'Czynniki ryzyka',
                  TREATMENT: 'Zabiegi i operacje',
               },
               diagnosis: {
                  chronic: 'Przewlekłe',
                  main: 'Główne',
               },
               failedToFetchMedicalInformation: 'Nie udało się pobrać danych medycznych',
               goBackToMedicalData: 'Wróć do listy kategorii',
               goToMedicalData: 'Przejdź do danych medycznych',
               listItemName: '{{name}} ({{count}})',
               medicalData: 'Dane medyczne',
               noMedicalData: 'Ten pacjent nie ma jeszcze dodanych wpisów',
            },
            notes: {
               emptyNote: 'Pusta notatka',
               noNotes: 'Ten pacjent nie ma jeszcze dodanych notatek',
               notes: 'Notatki',
            },
            patientConsentsAndAuthorizations: {
               actions: {
                  goToPatientConsentsAndAuthorizations: 'Przejdź do pełnego widoku',
               },
               authorizationContent: {
                  authorizationType: {
                     forDocumentation: 'Dokumentacja medyczna',
                     forInformation: 'Informacje o stanie zdrowia',
                  },
                  header: 'Upoważnienie',
                  identificationType: {
                     BIRTH_DATE: 'Data urodzenia',
                     NATIONAL_IDENTIFICATION_NUMBER: 'PIN UE',
                     PASSPORT: 'Paszport',
                     PESEL: 'PESEL',
                  },
               },
               consents: 'Zgody',
               header: 'Zgody i upoważnienia',
               noPatientConsents: 'Brak dodanych zgód lub upoważnień.',
            },
         },
         startVideoConsultation: 'Rozpocznij',
         stopwatch: {
            label: 'Wizyta trwa',
         },
         timeSlotTaken: 'Nie udało się przywrócić wizyty - na ten czas jest już zaplanowana inna wizyta.',
         /* eslint-enable*/
         visitDetails: {
            approveVisitForWhichVideoConsultationIsInProgress: 'Zatwierdzasz wizytę dla której trwa wideokonsultacja.',
            back: 'Wstecz',
            createdAndSentPatientRecords: 'Utworzono i wysłano dokumentację pacjenta',
            diagnoses: {
               chooseDiagnosis: 'Wybierz rozpoznanie',
               chronic: 'Przewlekła',
               copyChronicDiseases: 'Załaduj choroby przewlekłe',
               copyDiagnosesFromLastVisit: 'kopiuj rozpoznania z poprzedniej wizyty',
               diagnosis: 'Rozpoznania',
               diagnosisAdditionalInformation: {
                  form: {
                     additionalInformation: {
                        label: 'Dodatkowe informacje',
                        placeholder: 'Tu możesz rozszerzyć informacje o rozpoznaniu...',
                     },
                     diagnosis: {
                        label: 'Rozpoznanie',
                     },
                  },
                  modal: {
                     actions: {
                        confirm: {
                           label: 'Zapisz',
                        },
                     },
                     successfullyAddedDiagnosisAdditionalInformation: 'Notatka została zapisana.',
                     title: 'Dodatkowe informacje do rozpoznania',
                  },
               },
               diagnosisCounter: ' ({{count}})',
               diseaseName: 'Nazwa choroby',
               errors: {
                  add: 'Wystąpił błąd podczas dodawania rozpoznania.',
                  fetch: 'Nie udało się pobrać chorób przewlekłych pacjenta.',
               },
               icd10: 'ICD-10',
               interceptors: {
                  shared: {
                     faultHandlerMap: {
                        visitNotInUpdatableStatus: 'Nie można zaktualizować stanu wizyty, ponieważ została zamknięta.',
                     },
                  },
               },
               main: 'Główne',
               noDiagnosesAtPreviousVisit: 'Brak rozpoznań na poprzedniej wizycie.',
               noMainDiagnosis: 'Wybierz rozpoznanie główne',
               noResultsLabel: 'Nie postawiono żadnego rozpoznania',
               noResultsSubText:
                  'Uzupełnij kod ICD-10 lub nazwę choroby w wyszukiwarce i wybierz jedną z podpowiedzi lub <link />.',
               removalChronicDisease: {
                  form: {
                     chronicDiseaseRemovalDate: {
                        label: 'Data wykreślenia wpisu',
                        validate: {
                           cannotBeBeforeBeginVisitDate:
                              'Data wykreślenia wpisu nie może być wcześniejsza niż data dodania.',
                           cannotBeDateInFuture: 'Nie może być datą w przyszłości.',
                        },
                     },
                     chronicDiseaseRemovalReason: {
                        label: 'Powód',
                        placeholder: 'Podaj powód wykreślenia wpisu...',
                     },
                  },
                  modal: {
                     confirm: {
                        label: 'Oznacz jako wykreśloną',
                     },
                     message:
                        'Czy chcesz wykreślić <bold>{{code}} {{name}}</bold> z listy chorób przewlekłych? Nie \nusunie to wpisu z danych medycznych, ale przestanie być podpowiadane jako choroba przewlekła.',
                     title: 'Wykreślasz z listy chorób przewlekłych',
                  },
               },
               selectorPlaceholder: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
               tooManyMainDiagnoses: 'Wybierz maks. 1 rozpoznanie główne',
            },
            examination: {
               medicalImaging: {
                  emptyStatePlaceholder: {
                     addExamination: 'Dodaj badanie',
                     heading: 'Nie dodano żadnych badań',
                     subheading: 'Nie dodano wyników badań obrazowych podczas tej wizyty.',
                  },
                  failedToFetchMedicalInformation: 'Nie udało się pobrać wyników badania obrazowego. Spróbuj ponownie.',
                  modal: {
                     loading: 'Ładowanie badania obrazowego',
                  },
                  tab: 'Badania obrazowe',
                  table: {
                     examinationDate: 'Data badania',
                     icd9Code: 'ICD-9',
                     icd9Name: 'Nazwa procedury',
                     removed: 'Usunięty',
                  },
               },
               medicalInformation: {
                  categories: {
                     /* eslint-disable sort-keys-fix/sort-keys-fix */
                     ANTHROPOMETRY: 'Antropometria',
                     RISK_FACTOR: 'Czynniki ryzyka',
                     HOSPITALIZATION: 'Hospitalizacje',
                     MEDICAL_CONSULTATION: 'Konsultacje medyczne',
                     REHABILITATION: 'Rehabilitacje',
                     REFERRAL: 'Skierowanie',
                     ALLERGY: 'Uczulenia',
                     ANALYTICAL_TEST_RESULT: 'Wyniki badań analitycznych',
                     TREATMENT: 'Zabiegi i operacje',
                     OTHER: 'Inne',
                     /* eslint-enable sort-keys-fix/sort-keys-fix */
                  },
                  emptyStatePlaceholder: {
                     addExamination: 'Dodaj dane medyczne do kartoteki',
                     heading: 'Nie dodano żadnych danych medycznych',
                     subheading: 'Nie dodano danych medycznych podczas tej wizyty.',
                  },
                  failedToFetchMedicalInformation: 'Nie udało się pobrać danych medycznych. Spróbuj ponownie.',
                  tab: 'Inne',
                  table: {
                     creationDate: 'Data wpisu',
                     removed: 'Usunięty',
                     type: 'Kategoria wpisu',
                  },
               },
               subjectiveAssessment: {
                  label: 'Badanie przedmiotowe',
                  placeholder: 'Uzupełnij badanie przedmiotowe...',
                  tab: 'Badanie przedmiotowe',
               },
            },
            formattingLimitExceeded: {
               snackbar: {
                  fieldName: {
                     interview: 'Wywiadu',
                     recommendations: 'Zaleceń',
                     subjectiveAssessment: 'Badania przedmiotowego',
                  },
                  message: 'Nie udało się zapisać wersji roboczej dla {{fieldName}} - zbyt długa treść wpisu.',
               },
            },
            interview: 'Wywiad',
            interviewPlaceholder: 'Uzupełnij wywiad z pacjentem...',
            invalidProcedure: 'Niepoprawna procedura "{{procedure}}". Usuń ją i spróbuj ponownie.',
            leavingPrompt: {
               failMessage:
                  'Nie mogliśmy zapisać danych wizyty, czy chcesz przejść dalej? \nNiezapisane dane zostaną utracone.',
               successMessage: 'Wersja robocza wizyty została zapisana.',
               title: 'Błąd zapisu wersji roboczej',
            },
            mainDiagnosisNotSelected: 'Nie wybrano rozpoznania głównego.',
            minimalDataValidation: 'Należy wypełnić wszystkie pola',
            preInterview: {
               actions: {
                  preview: 'Pre-wywiad',
               },
               dialog: {
                  actions: {
                     confirm: 'Zamknij',
                     copy: 'Kopiuj do wywiadu',
                  },
                  approvalDateText: 'Zatwierdzono: {{date}}, {{time}}',
                  title: 'Pre-wywiad',
               },
               tooltip: {
                  content: 'Pre-wywiad nie został uzupełniony dla tej wizyty.',
               },
            },
            printFromVisit: 'Drukowanie z wizyty',
            procedures: {
               icd9: 'ICD-9',
               limitReached: 'Zbyt duża liczba procedur (maks. 50)',
               noResultsLabel: 'Nie postawiono żadnej procedury medycznej',
               noResultsSubText:
                  'Uzupełnij kod ICD-9 lub nazwę procedury w wyszukiwarce i wybierz jedną z podpowiedzi.',
               procedureName: 'Nazwa procedury',
               procedures: 'Procedury medyczne ({{count}})',
               quantity: 'Krotność',
               selectorPlaceholder: 'Uzupełnij kod ICD-9 lub nazwę procedury...',
            },
            recommendations: {
               actions: {
                  back: 'Wstecz',
                  creatingPrint: 'Tworzenie druku zaleceń',
                  print: 'Drukuj',
                  send: 'Wyślij',
                  sharingPrint: 'Udostępnianie druku zaleceń',
               },
               field: {
                  label: 'Zalecenia',
                  placeholder: 'Uzupełnij zalecenia dla pacjenta...',
               },
               patientRecommendationsWereCreatedAndSent: 'Utworzono i wysłano zalecenia dla pacjenta',
               sentRecommendationsToPatientAndSmsMessageWithPassword:
                  'Wysłaliśmy zalecenia do pacjenta oraz wiadomość SMS z poniższym hasłem.',
               shareRecommendationsWithPatient: 'Udostępnij zalecenia pacjentowi',
               smsWithPasswordToEncryptedFileWillBeSentToThisNumber:
                  'Na ten numer zostanie wysłany SMS z hasłem do zaszyfrowanego pliku.',
               tab: 'Zalecenia',
            },
            send: 'Wyślij',
            sentDocumentationToPatientAndSmsMessageWithPassword:
               'Wysłaliśmy dokumentację do pacjenta oraz wiadomość SMS z poniższym hasłem.',
            shareRecordsWithPatient: 'Udostępnij dokumentację pacjentowi',
            visitConfirmed: 'Zatwierdzono wizytę.',
            visitSaved: 'Zapisano wizytę.',
         },
         visitHistory: {
            alreadyDisplayingAllVisits: 'Wyświetlamy już wszystkie wizyty w historii pacjenta.',
            annulledVisible: 'Pokazuj usunięte',
            back: 'Wstecz',
            bookVisit: 'Zaplanuj wizytę',
            createdAndSentPatientRecords: 'Utworzono i wysłano dokumentację pacjenta',
            diagnosisTable: {
               chronic: 'Przewlekła',
               diseaseName: 'Nazwa choroby',
               icd10: 'ICD-10',
               main: 'Główne',
            },
            documentTabs: {
               electronicDocuments: 'EDM',
               electronicReferrals: 'eSkierowania',
               medicalDocuments: 'Druki',
               medicalLeaves: 'eZwolnienia',
               patientConsents: 'Zgody',
               prescriptions: 'eRecepty',
            },
            electronicDocumentsTable: {
               diagnosis: 'Rozpoznanie',
               documentTypeMap: {
                  DISCHARGE_SUMMARY: 'Informacja dla lekarza kierującego',
               },
               noElectronicDocuments: 'Brak wysłanych EDM',
               noElectronicDocumentsIssued: 'Na wybranej wizycie nie wystawiono żadnych dokumentów w formie EDM.',
               procedure: 'Procedura',
               type: 'Typ',
            },
            electronicReferralTable: {
               accessCode: 'Kod',
               cito: 'Pilne',
               diagnoses: 'Rozpoznanie',
               examinationTypes: 'Procedura',
               locationSpecialtyName: 'Oddział/Pracownia',
               noElectronicReferrals: 'Brak eSkierowań',
               noElectronicReferralsWereIssued: 'Na wybranej wizycie nie wystawiono żadnych eSkierowań.',
               referralType: 'Typ',
               referralTypeMap: {
                  DIAGNOSTIC_EXAMINATION: 'Skierowanie do pracowni diagnostycznej',
                  HOSPITAL: 'Skierowanie do szpitala',
                  SPECIALIST: 'Skierowanie do specjalisty',
               },
            },
            interview: 'Wywiad',
            interviewNotCompleted: 'Nie uzupełniono wywiadu',
            interviewTabs: {
               diagnosis: 'Rozpoznania',
               procedures: 'Procedury medyczne',
            },
            loadOlderVisits: 'Załaduj starsze wizyty',
            medicalDocumentsTable: {
               creationDate: 'Data i godzina',
               noMedicalDocuments: 'Brak druków',
               noMedicalDocumentsWereIssued: 'Na wybranej wizycie nie wystawiono żadnych druków.',
               typeName: 'Rodzaj',
            },
            medicalImaging: 'Badania obrazowe',
            medicalImagingDescription: 'Opis: {{description}}',
            medicalImagingExaminationDate: 'Data badania: {{date}} o g. {{time}}',
            medicalImagingFetchError: 'Nie udało się pobrać informacji o załącznikach. Spróbuj ponownie.',

            medicalLeavesTable: {
               daysCount: 'Dni',
               forGuardian: 'Na opiekę',
               identificationNumberType: {
                  NIP: 'NIP',
                  PASSPORT_NUMBER: 'Paszport',
                  PESEL: 'PESEL',
               },
               insuranceType: {
                  KRUS: 'KRUS',
                  NONE: '-',
                  OTHER_FOREIGN: 'W innym państwie',
                  OTHER_POLAND: 'Innym w Polsce',
                  ZUS: 'ZUS',
               },
               noMedicalLeaves: 'Brak eZwolnień',
               noMedicalLeavesWereIssued: 'Na wybranej wizycie nie wystawiono żadnych eZwolnień.',
               payer: 'Płatnik',
               payerPueAccount: 'PUE',
               period: 'Okres',
               serialNumber: 'Seria i numer',
            },
            noVisitHistory: 'Brak wizyt historycznych',
            options: {
               printOrShareVisitDocuments: 'Drukuj lub udostępnij dokumenty z wizyty',
               printVisitDocuments: 'Drukuj dokumenty z wizyty',
               visitReopen: 'Otwórz ponownie',
               visitSummaryPrint: {
                  label: 'Drukuj kartę wizyty',
                  printError: 'Nie udało się wydrukować karty wizyty. Spróbuj ponownie.',
               },
            },
            otherExaminationDescription: 'Opis: {{description}}',
            otherExaminationExaminationDate: 'Data badania: {{date}} o g. {{time}}',
            otherExaminationFetchError: 'Nie udało się pobrać informacji o załącznikach. Spróbuj ponownie.',
            otherExaminations: 'Inne',
            patientConsentsTable: {
               addDocumentScan: 'Dodaj skan dokumentu',
               creationDate: 'Data i godzina',
               name: 'Nazwa',
               noPatientConsents: 'Brak zgód',
               noPatientConsentsWereIssued: 'Nie wygenerowano żadnych dokumentów zgód na tej wizycie.',
               scanWithSignature: 'Skan z podpisem',
            },
            patientHasNotHadAnyVisits: 'Pacjent nie odbył żadnych wizyt.',
            prescriptionsTable: {
               accessCode: 'Kod',
               commercialName: 'Nazwa handlowa',
               dosage: 'DS',
               noPrescriptions: 'Brak eRecept',
               noPrescriptionsWereIssued: 'Na wybranej wizycie nie wystawiono żadnych eRecept.',
               quantity: 'Opak.',
               reimbursementType: 'Odpł.',
               reimbursements: {
                  B: 'B ',
                  FULL: '100%',
                  HALF: '50%',
                  R: 'R',
                  THIRTY_PERCENT: '30%',
               },
            },
            print: 'Drukuj',
            printFromVisit: 'Drukowanie z wizyty',
            proceduresTable: {
               code: 'ICD-9',
               noMedicalProceduresSpecified: 'Na wybranej wizycie nie określono żadnych procedur medycznych.',
               noProcedures: 'Brak procedur',
               procedureName: 'Nazwa procedury',
               quantity: 'Krotność',
            },
            recommendations: 'Zalecenia',
            recommendationsNotCompleted: 'Nie uzupełniono zaleceń',
            removed: 'Usunięty',
            request: 'Poproś o dostęp',
            requestPending: 'Wysłano prośbę o dostęp',
            send: 'Wyślij',
            sentDocumentationToPatientAndSmsMessageWithPassword:
               'Wysłaliśmy dokumentację do pacjenta oraz wiadomość SMS z poniższym hasłem.',
            share: 'Udostępnij',
            shareNotAvailableForOtherDocuments:
               'Ta opcja jest na razie niedostępna dla pozostałych dokumentów z wizyty.',
            shareRecordsWithPatient: 'Udostępnij dokumentację pacjentowi',
            subjectiveAssessment: 'Badanie przedmiotowe',
            subjectiveAssessmentNotCompleted: 'Nie uzupełniono badań przedmiotowych',
         },
         visitLocationNotUpdatableFault:
            'Miejsce udzielania świadczeń nie może już zostać zmienione, ponieważ prawdopodobnie wystawiono już jakieś dokumenty.',
         visitTemplates: {
            addNewTemplate: 'Dodaj nowy szablon',
            cancel: 'Anuluj',
            close: 'Zamknij',
            deleteTemplate: 'Usuń szablon',
            deletingTemplate: 'Usuwasz szablon',
            doYouWantToDeleteTemplate: 'Czy na pewno chcesz usunąć szablon {{name}}?',
            doYouWantToLeaveEdition: 'Czy na pewno chcesz wyjść z edycji {{name}}? Niezapisane dane zostaną utracone.',
            doYouWantToSaveEmptyTemplate: 'Czy na pewno chcesz zapisać pusty szablon?',
            enterInterview: 'Uzupełnij szablon wywiadu...',
            enterRecommendations: 'Uzupełnij szablon zaleceń...',
            enterSubjectiveAssessment: 'Uzupełnij szablon badania przedmiotowego...',
            enterTemplateName: 'Uzupełnij nazwę szablonu...',
            insert: 'Wstaw',
            inserted: 'Wstawione',
            interview: 'Wywiad',
            leavingEdition: 'Wychodzisz z edycji',
            name: 'Nazwa szablonu',
            newTemplate: 'Nowy szablon',
            noAvailableVisitTemplatesYet: 'Nie utworzono jeszcze żadnego szablonu wizyty',
            noInterview: 'Brak wywiadu',
            noRecommendations: 'Brak zaleceń',
            noSubjectiveAssessments: 'Brak badań przedmiotowych',
            noTemplates: 'Brak szablonów',
            recommendations: 'Zalecenia',
            saveTemplate: 'Zapisz szablon',
            savingEmptyTemplate: 'Zapisujesz pusty szablon',
            subjectiveAssessment: 'Badanie przedmiotowe',
            successfullyAddedTemplate: 'Szablon {{name}} został dodany.',
            successfullyDeletedTemplate: 'Szablon {{name}} został usunięty.',
            successfullyUpdatedTemplate: 'Szablon {{name}} został zaktualizowany.',
            templateName: 'Nazwa szablonu',
            templateNameOccupied: 'Szablon o takiej nazwie już istnieje.',
            templateWithGivenNameAlreadyExists: 'Szablon o podanej nazwie już istnieje',
            templatesFetchError: 'Błąd pobrania listy szablonów. Spróbuj ponownie.',
            useTemplate: 'Użyj szablonu',
            visitTemplates: 'Szablony wizyt',
         },
         visitsHistory: 'Historia wizyt',
      },
   },
};

export const visitTranslationKeys = createScopedTranslationKeys(translations.pl, 'visit');
export const visitActionBarTranslationKeys = visitTranslationKeys.actionBar;
export const documentTemplateActionTranslationKeys = visitTranslationKeys.actionBar.documentTemplate;
export const consentTemplateActionTranslationKeys = visitTranslationKeys.actionBar.consentTemplate;
export const visitPrescriptionTranslationKeys = visitTranslationKeys.prescription;
export const visitTemplatesTranslationKeys = visitTranslationKeys.visitTemplates;
export const prescriptionVisitTemplatesTranslationKeys = visitTranslationKeys.prescriptionVisitTemplates;
export const appointmentsTranslationKeys = visitTranslationKeys.appointments;
export const calendarTranslationKeys = visitTranslationKeys.calendar;
export const waitlistEntryTranslationKeys = calendarTranslationKeys.waitlistEntry;
export const visitDetailsTranslationKeys = visitTranslationKeys.visitDetails;
export const documentSigningKeys = visitTranslationKeys.documentSigning;
export const sidePanelTranslationKeys = visitTranslationKeys.sidePanel;
export const historicalVisitsTranslationKeys = sidePanelTranslationKeys.historicalVisits;
export const historicalVisitTranslationKeys = sidePanelTranslationKeys.historicalVisits.historicalVisit;
export const medicalDataTranslationKeys = sidePanelTranslationKeys.medicalData;
export const notesTranslationKeys = sidePanelTranslationKeys.notes;
export const patientConsentsAndAuthorizationsTranslationKeys =
   sidePanelTranslationKeys.patientConsentsAndAuthorizations;
export const aiAssistantSidePanelTranslationKeys = sidePanelTranslationKeys.aiAssistant;
export const visitPatientDetailsKeys = visitTranslationKeys.patientDetails;
export const visitHistoryTranslationKeys = visitTranslationKeys.visitHistory;
export const visitPatientPregnancyStatusTranslationKeys = visitTranslationKeys.pregnancyStatus;
export const medicalImagingTranslationKeys = visitDetailsTranslationKeys.examination.medicalImaging;
export const subjectiveAssessmentTranslationKeys = visitDetailsTranslationKeys.examination.subjectiveAssessment;
export const medicalInformationTranslationKeys = visitDetailsTranslationKeys.examination.medicalInformation;
export const recommendationsTranslationKeys = visitDetailsTranslationKeys.recommendations;

// Ezla
export const medicalLeaveTranslationKeys = visitTranslationKeys.ezla;
export const historicalLeavesTranslationKeys = medicalLeaveTranslationKeys.historicalLeaves;
export const guardianTranslationKeys = medicalLeaveTranslationKeys.guardianMedicalLeaveForm;
export const commonTranslationKeys = medicalLeaveTranslationKeys.common;
export const medicalLeaveFormTranslationKeys = medicalLeaveTranslationKeys.medicalLeaveForm;
export const identityDocumentTranslationKeys = medicalLeaveTranslationKeys.identityDocument;
export const passportIdentityDocument = medicalLeaveTranslationKeys.identityDocument.passport;

// Prescriptions
export const prescriptionsTranslationKeys = visitTranslationKeys.prescriptions;
export const prescriptionTranslationKeys = prescriptionsTranslationKeys.prescription;
export const reimbursementsTranslationKeys = prescriptionsTranslationKeys.reimbursements;
export const medicineTranslationKeys = prescriptionsTranslationKeys.medicine;
export const medicineSelectorTranslationKeys = prescriptionsTranslationKeys.medicineSelector;
export const draftPrescriptionsTranslationKeys = prescriptionsTranslationKeys.draftPrescriptions;
export const sentPrescriptionPackagesTranslationKeys = prescriptionsTranslationKeys.sentPrescriptionPackages;
export const magistralDrugTranslationKeys = prescriptionsTranslationKeys.magistralDrug;
export const annulledPrescriptionsTranslationKeys = sentPrescriptionPackagesTranslationKeys.annulledPrescriptions;
export const magistralDrugTemplatesTranslationKeys = prescriptionsTranslationKeys.templates.magistralDrug;
export const extendedDosageTemplatesTranslationKeys = prescriptionsTranslationKeys.templates.extendedDosage;

// Nfz
export const nfzTranslationKeys = visitTranslationKeys.nfz;

// Common
export const commonVisitTranslationKeys = visitTranslationKeys.common;

// Prescription Visits
export const prescriptionVisitsTranslationKeys = visitTranslationKeys.prescriptionVisits;
